import React, { useState, useEffect, useMemo, useRef } from "react";

import api from "../../services/api";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";
import buscaCep from "../../services/buscaCep";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";

import Tooltip from "../../components/tooltip";
import { store } from "react-notifications-component";

import HeaderV2 from "../../components/headerV2";
import CardRadio from "../../components/cardRadio";
import AcordionCard from "../../components/acordionCard";
import InputV3 from "../../components/input/novo/input_v3";
import ModalTermos from "../../components/modal/modalTermos";
import ModalPoliticas from "../../components/modal/modalPoliticas";
import AcordionCardSimulation from "../../components/acordionCard/acordionCardSimulation";
import ModalYesNoV2 from "../../components/modal/modalYesNoV2";

import ModalImage from "../../assets/envelope-image.svg";
import IconInfoBlack from "../../assets/icons8-info-black.svg";

import * as S from "./compraStyles";
import { theme } from "../../styles/theme";
import {
  Auxiliar,
  BodyG,
  BodyP,
  H6,
  Minimo,
  TaglineM,
} from "../../styles/stylesTypography";

export const USER = "@userinfo";

const PURCHASE_DATALAYER_KEY = "@datalayer_purchase";

const Compra = ({ ...props }) => {
  useEffect(() => {
    const updateReload = localStorage.getItem("@UpdateReload");

    if (updateReload === "true") {
      localStorage.setItem("@UpdateReload", "false");
      window.location.reload();
    }
  }, []);

  // Params
  const [urlParams, setUrlParams] = useState({
    utm_campaign: "",
    utm_source: "",
    utm_medium: "",
    utm_id: "",
    button: "",
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      const allowedParams = ["utm_campaign", "utm_source", "utm_medium", "utm_id", "button"];

      const filteredParams = {};
      allowedParams.forEach((param) => {
        filteredParams[param] = params.get(param) || "";
      });

      setUrlParams(filteredParams);
    }
  }, []);

  //Acordions
  const [openedAccordion, setOpenedAccordion] = useState(null);
  const [openAccordionKey, setOpenAccordionKey] = useState(null);

  const [activeAccordionUser, setActiveAccordionUser] = useState(false);
  const [activeAccordionEmpresa, setActiveAccordionEmpresa] = useState(true);
  const [activeAccordionFaturamento, setActiveAccordionFaturamento] =
    useState(true);
  const [activeAccordionPagamento, setActiveAccordionPagamento] =
    useState(true);

  //Notifications
  const notificationShown = useRef(false);
  const cpfCnpjEmpresaCheckRef = useRef(0);
  const cpfOrCnpjPagamentoCheckRef = useRef(0);
  const cpfUserCheckRef = useRef(0);

  // Pendência de plano/pagamento
  const [hasPendingPayment, setHasPendingPayment] = useState(false);
  const [showPendingModal, setShowPendingModal] = useState(false);
  const [pendingConfirmedOnce, setPendingConfirmedOnce] = useState(false);

  //Validação
  const [startValidationUser, setStartValidationUser] = useState(false);
  const [startValidationEmpresa, setStartValidationEmpresa] = useState(false);
  const [startValidationFaturamento, setStartValidationFaturamento] =
    useState(false);
  const [startValidationPagamento, setStartValidationPagamento] =
    useState(false);

  //Acordion 1
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [idPlanCard, setIdPlanCard] = useState(0);
  const [idPlanGridCard, setIdPlanGridCard] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [cupom, setCupom] = useState("");
  const [revenues, setRevenues] = useState(0);

  const [qtdDocuments, setQtdDocuments] = useState("");
  const [qtdPrescriptions, setQtdPrescriptions] = useState("");

  const [valuePerMonth, setValuePerMonth] = useState("");
  const [resultvalueUserMonth, setResultValueUserMonth] = useState("");
  const [valueRevenuesPrePago, setValueRevenuesPrePago] = useState("");
  const [
    valueRevenuesPrePagoWithNotDiscount,
    setValueRevenuesPrePagoWithNotDiscount,
  ] = useState("");
  const [resultValuePrepago, setResultValuePrepago] = useState("");
  const [resultValueMonth, setResultValueMonth] = useState("");

  const [discountMonths, setDiscountMonths] = useState(0);
  const [messageCupom, setMessageCupom] = useState("");
  const [cupomRecorrencia, setCupomRecorrencia] = useState(null);
  const [valueMonthNotDiscount, setValueMonthNotDiscount] = useState("");
  const [valueMonthWithDiscount, setValueMonthWithDiscount] = useState("");
  const [valueMonth, setValueMonth] = useState("");
  const [valueAnual, setValueAnual] = useState("");
  const [fullValueAnual, setFullValueAnual] = useState("");

  // const [valueAnual, setValueAnual] = useState("");
  // const [fullValueAnual, setFullValueAnual] = useState("");

  const [valueAnualCalcWithMonth, setValueAnualCalcWithMonth] = useState("");

  const [resultValueTotalWithDiscount, setResultValuetotalWithDiscount] =
    useState("");

  const [valueMonthDiscount, setValueMonthDiscount] = useState("");
  const [valueTotalWithDiscount, setValueTotalWithDiscount] = useState("");

  const [acordionPlanError, setAcordionPlanError] = useState(false);
  const [errorsPlan, setErrorsPlan] = useState({
    selectedPlan: false,
    userCount: false,
    revenues: false,
  });

  //Acordion 2
  const [nameUser, setNameUser] = useState("");
  const [emailUser, setEmailUser] = useState("");
  const [phoneUser, setPhoneUser] = useState("");

  const [cargoUser, setCargoUser] = useState("");

  const [workSpaceUser, setWorkSpaceUser] = useState({
    value: "",
    label: "",
  });
  const [workSpaceOptions, setWorkSpaceOptions] = useState([]);
  const [cpfUser, setCpfUser] = useState("");
  const [rgUser, setRgUser] = useState("");

  const [isResponsavelTecnico, setIsResponsavelTecnico] = useState(false);

  const [acordionUserError, setAcordionUserError] = useState(false);
  const [errorsUser, setErrorsUser] = useState({
    nameUser: false,
    emailUser: false,
    phoneUser: false,
    cargoUser: false,
    workSpaceUser: false,
    cpfUser: false,
    rgUser: false,
  });

  //Acordion 3
  const [cpfCnpjEmpresa, setCpfOrCnpjEmpresa] = useState("");
  const [getCpfCnpjEmpresa, setGetCpfOrCnpjEmpresa] = useState("");

  const [showOtherFields, setShowOtherFields] = useState(false);

  const [nomeCompletoEmpresa, setNomeCompletoEmpresa] = useState("");
  const [rgEmpresa, setRgEmpresa] = useState("");

  const [razaoSocialEmpresa, setRazaoSocialEmpresa] = useState("");
  const [telefoneEmpresa, setTelefoneEmpresa] = useState("");
  const [nomeFantasiaEmpresa, setNomeFantasiaEmpresa] = useState("");
  const [cepEmpresa, setCepEmpresa] = useState("");
  const [enderecoEmpresa, setEnderecoEmpresa] = useState("");
  const [numeroEmpresa, setNumeroEmpresa] = useState("");
  const [complementoEmpresa, setComplementoEmpresa] = useState("");
  const [bairroEmpresa, setBairroEmpresa] = useState("");
  const [cidadeEmpresa, setCidadeEmpresa] = useState("");
  const [ufEmpresa, setUfEmpresa] = useState({ value: "", label: "" });
  const [inscricaoEstadualEmpresa, setInscricaoEstadualEmpresa] = useState("");
  const [categoriaEmpresa, setCategoriaEmpresa] = useState({
    value: "",
    label: "",
  });
  const [categoriaOptions, setCategoriaOptions] = useState([]);

  const [acordionEmpresaError, setAcordionEmpresaError] = useState(false);
  const [errorsEmpresa, setErrorsEmpresa] = useState({
    cpfCnpjEmpresa: false,
    nomeCompletoEmpresa: false,
    rgEmpresa: false,
    razaoSocialEmpresa: false,
    telefoneEmpresa: false,
    nomeFantasiaEmpresa: false,
    cepEmpresa: false,
    enderecoEmpresa: false,
    numeroEmpresa: false,
    complementoEmpresa: false,
    bairroEmpresa: false,
    cidadeEmpresa: false,
    ufEmpresa: false,
    inscricaoEstadualEmpresa: false,
    categoriaEmpresa: false,
  });

  //Acordion 4
  const [nameUserFaturamento, setNameUserFaturamento] = useState("");
  const [emailUserFaturamento, setEmailUserFaturamento] = useState("");
  const [phoneUserFaturamento, setPhoneUserFaturamento] = useState("");

  const [cargoUserFaturamento, setCargoUserFaturamento] = useState("");

  const [workSpaceFaturamento, setWorkSpaceFaturamento] = useState({
    value: "",
    label: "",
  });
  const [numeroPedidoFaturamento, setNumeroPedidoFaturamento] = useState("");

  const [acordionFaturamentoError, setAcordionFaturamentoError] =
    useState(false);
  const [errorsFaturamento, setErrorsFaturamento] = useState({
    nameUserFaturamento: false,
    emailUserFaturamento: false,
    phoneUserFaturamento: false,
    cargoUserFaturamento: false,
    workSpaceFaturamento: false,
  });

  //Acordion 5
  const [selectedMetod, setSelectedMetod] = useState("pix");
  const [parcelasOptions, setParcelasOptions] = useState([]);
  const [selectedParcelas, setSelectedParcelas] = useState({
    value: "",
    label: "",
    valor_parcela: "",
    total_juros: "",
  });

  const [cpfOrCnpjPagamento, setCpfOrCnpjPagamento] = useState("");
  const [emailPagamento, setEmailPagamento] = useState("");
  const [phonePagamento, setPhonePagamento] = useState("");
  const [cepPagamento, setCepPagamento] = useState("");
  const [enderecoPagamento, setEnderecoPagamento] = useState("");
  const [numeroPagamento, setNumeroPagamento] = useState("");
  const [complementoPagamento, setComplementoPagamento] = useState("");
  const [bairroPagamento, setBairroPagamento] = useState("");
  const [cidadePagamento, setCidadePagamento] = useState("");

  const [ufPagamento, setUFPagamento] = useState({
    value: "",
    label: "",
  });

  const ufOptions = [
    { value: "AC", label: "Acre" },
    { value: "AL", label: "Alagoas" },
    { value: "AP", label: "Amapá" },
    { value: "AM", label: "Amazonas" },
    { value: "BA", label: "Bahia" },
    { value: "CE", label: "Ceará" },
    { value: "DF", label: "Distrito Federal" },
    { value: "ES", label: "Espírito Santo" },
    { value: "GO", label: "Goiás" },
    { value: "MA", label: "Maranhão" },
    { value: "MT", label: "Mato Grosso" },
    { value: "MS", label: "Mato Grosso do Sul" },
    { value: "MG", label: "Minas Gerais" },
    { value: "PA", label: "Pará" },
    { value: "PB", label: "Paraíba" },
    { value: "PR", label: "Paraná" },
    { value: "PE", label: "Pernambuco" },
    { value: "PI", label: "Piauí" },
    { value: "RJ", label: "Rio de Janeiro" },
    { value: "RN", label: "Rio Grande do Norte" },
    { value: "RS", label: "Rio Grande do Sul" },
    { value: "RO", label: "Rondônia" },
    { value: "RR", label: "Roraima" },
    { value: "SC", label: "Santa Catarina" },
    { value: "SP", label: "São Paulo" },
    { value: "SE", label: "Sergipe" },
    { value: "TO", label: "Tocantins" },
  ];

  //cartão de crédito do titular
  const [nomeTitularCartao, setNomeTitularCartao] = useState("");
  const [numeroCartao, setNumeroCartao] = useState("");
  const [validade, setValidade] = useState("");
  const [cvv, setCvv] = useState("");

  const [acordionPagamentoError, setAcordionPagamentoError] = useState(false);
  const [errorsPagamento, setErrorsPagamento] = useState({
    parcelas: false,
    cpfOrCnpjPagamento: false,
    emailPagamento: false,
    phonePagamento: false,
    cepPagamento: false,
    enderecoPagamento: false,
    numeroPagamento: false,
    complementoPagamento: false,
    bairroPagamento: false,
    cidadePagamento: false,
    ufPagamento: false,

    nomeTitularCartao: false,
    numeroCartao: false,
    validade: false,
    cvv: false,
  });

  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const [termosAceitos, setTermosAceitos] = useState(false);
  const [acordoAceito, setAcordoAceito] = useState(false);

  const [showTermos, setShowTermos] = useState(false);
  const [showPolitica, setShowPolitica] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const headerElement = document.getElementById("header");
      if (headerElement) {
        headerElement.scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const saveGtmDataCompra = () => {
    localStorage.setItem('gtm_data_compra', JSON.stringify({
      nome: nameUser,
      email: emailUser,
      telefone: phoneUser,
    }));
  };

  const tagRdStation = async () => {
    try {
      await api.get(`/compra/tag-carrinho`);
    } catch {}
  };

  useEffect(() => {
    return () => {
      tagRdStation();
    };
  }, []);

  const getInformationUser = async () => {
    try {
      const response = await api.get(`/planos/conta/info`);
      const workspacesResponse = await api.get(`/workspaces`);
      const workspaces = workspacesResponse.data.data;
      setWorkSpaceOptions(workspaces);

      const categoriasResponse = await api.get(`/info/categorias`);

      const formattedCategoria = categoriasResponse.data.data.map((depto) => ({
        value: depto.id,
        label: depto.nome,
      }));

      if (response) {
        //Dados do usuário
        const nome = response.data.data.compra?.nome;
        const email = response.data.data.compra?.email;
        const telefone = response.data.data.compra?.telefone;
        const whatsapp = response.data.data.compra?.whatsapp;
        const cargo = response.data.data.compra?.cargo;
        const workspaceId = response.data.data.compra?.workspace_id;
        const cpf = response.data.data.compra?.cpf;
        const rg = response.data.data.compra?.rg;
        const isAgronomo =
          response.data.data.compra?.is_agronomist === 1 ? true : false;

        setNameUser(nome);
        setEmailUser(email);
        setPhoneUser(telefone && telefone !== "-" ? telefone : whatsapp);
        setCargoUser(cargo);
        setCpfUser(cpf);
        setRgUser(rg);
        setIsResponsavelTecnico(isAgronomo);

        if (workspaceId && Array.isArray(workspaces) && workspaces.length > 0) {
          const workspaceEncontrado = workspaces.find(
            (workspace) => workspace.value === workspaceId
          );
          if (workspaceEncontrado) {
            setWorkSpaceUser({
              value: workspaceEncontrado.value,
              label: workspaceEncontrado.label,
            });
          }
        }

        //Dados da empresa
        const cpfEmpresa = response.data.data.company?.cpf;
        const cnpjEmpresa = response.data.data.company?.cnpj;
        const cnpjOrCpfEmpresa = cpfEmpresa !== null ? cpfEmpresa : cnpjEmpresa;

        const NomeEmpresa = response.data.data.company?.nome_fantasia;
        const RazaoSocialEmpresa = response.data.data.company?.razao_social;

        const NomeCompletoEmpresa = NomeEmpresa
          ? NomeEmpresa
          : RazaoSocialEmpresa;
        const telefoneEmpresa = response.data.data.company?.telefone1;
        const rgEmpresa = response.data.data.company?.ie;
        const cepEmpresa = response.data.data.company?.cep;
        const enderecoEmpresaApi = response.data.data.company?.endereco;
        const bairroEmpresaApi = response.data.data.company?.bairro;
        const complementoEmpresa = response.data.data.company?.complemento;
        const numeroEmpresa = response.data.data.company?.numero;
        const categoriaEmpresa =
          response.data.data.company?.company_category_id;

        const inscricaoEstadualEmpresa = response.data.data.company?.ie;

        setCpfOrCnpjEmpresa(cpfEmpresa !== null ? cpfEmpresa : cnpjEmpresa);

        const resultadoDocEmpresa = cnpjOrCpfEmpresa
          ? await validadorCpfCnpj(cnpjOrCpfEmpresa)
          : { valido: false };

        if (resultadoDocEmpresa.valido) {
          setShowOtherFields(true);

          setRazaoSocialEmpresa(RazaoSocialEmpresa);
          setNomeFantasiaEmpresa(NomeEmpresa);
          setNomeCompletoEmpresa(NomeCompletoEmpresa);
          setTelefoneEmpresa(telefoneEmpresa);
          setRgEmpresa(rgEmpresa);
          setCepEmpresa(
            cepEmpresa && cepEmpresa !== "00.000.000" ? cepEmpresa : ""
          );
          setEnderecoEmpresa(enderecoEmpresaApi || "");
          setBairroEmpresa(bairroEmpresaApi || "");
          setComplementoEmpresa(complementoEmpresa);
          setNumeroEmpresa(numeroEmpresa);

          if (cepEmpresa && cepEmpresa !== "00.000.000") {
            fetchCep(cepEmpresa, "empresa");
          }

          if (
            categoriaEmpresa &&
            Array.isArray(formattedCategoria) &&
            formattedCategoria.length > 0
          ) {
            const categoriaEncontrado = formattedCategoria.find(
              (item) => item.value === categoriaEmpresa
            );

            if (categoriaEncontrado) {
              setCategoriaEmpresa({
                value: categoriaEncontrado.value,
                label: categoriaEncontrado.label,
              });
            }
          }

          setInscricaoEstadualEmpresa(inscricaoEstadualEmpresa);
        }

        if (cpfEmpresa !== null || cnpjEmpresa !== null) {
          handleCnpj(cpfCnpjEmpresa, "empresa");
        }

        //Dados de faturamento
        const nomeFaturamento = response.data.data.faturamento?.nome;
        const emailFaturamento = response.data.data.faturamento?.email;
        const telefoneFaturamento = response.data.data.faturamento?.telefone;
        const cargoFaturamento = response.data.data.faturamento?.cargo;
        const workspaceIdFaturamento =
          response.data.data.faturamento?.contact_area_id;
        const numeroPedido = response.data.data.faturamento?.numero_pedido;

        setNameUserFaturamento(nomeFaturamento);
        setEmailUserFaturamento(emailFaturamento);
        setPhoneUserFaturamento(telefoneFaturamento);
        setCargoUserFaturamento(cargoFaturamento);
        setNumeroPedidoFaturamento(numeroPedido ? numeroPedido : "");

        if (
          workspaceIdFaturamento &&
          Array.isArray(workspaces) &&
          workspaces.length > 0
        ) {
          const workspaceEncontrado = workspaces.find(
            (workspace) => workspace.value === workspaceIdFaturamento
          );
          if (workspaceEncontrado) {
            setWorkSpaceFaturamento({
              value: workspaceEncontrado.value,
              label: workspaceEncontrado.label,
            });
          }
        }

        //Dados de pagamento
        const cpfOrCnpjPagamento = response.data.data.pagamento?.cpf_cnpj;
        const emailPagamento = response.data.data.pagamento?.email;
        const telefonePagamento = response.data.data.pagamento?.telefone;
        const cepPagamento = response.data.data.pagamento?.cep;
        const enderecoPagamento = response.data.data.pagamento?.endereco;
        const numeroPagamento = response.data.data.pagamento?.numero;
        const complementoPagamento = response.data.data.pagamento?.complemento;
        const bairroPagamento = response.data.data.pagamento?.bairro;
        const cidadePagamento = response.data.data.pagamento?.cidade;

        //Cartão
        const nameCartaoPagamento = response.data.data.pagamento?.name;
        const numeroCartaoPagamento = response.data.data.pagamento?.num_card;

        const mesCartaoPagamento = response.data.data.pagamento?.expire_month;
        const anoCartaoPagamento = response.data.data.pagamento?.expire_year;

        setCpfOrCnpjPagamento(cpfOrCnpjPagamento);
        setEmailPagamento(emailPagamento);
        setPhonePagamento(telefonePagamento);
        setCepPagamento(cepPagamento);
        setEnderecoPagamento(enderecoPagamento);
        setNumeroPagamento(numeroPagamento);
        setComplementoPagamento(complementoPagamento);
        setBairroPagamento(bairroPagamento);
        setCidadePagamento(cidadePagamento);

        if (cepPagamento && cepPagamento !== "00.000.000") {
          fetchCep(cepPagamento, "pagamento");
        }

        setNomeTitularCartao(nameCartaoPagamento);
        setNumeroCartao(numeroCartaoPagamento);

        let validade = "";
        if (mesCartaoPagamento && anoCartaoPagamento) {
          validade = `${mesCartaoPagamento}20${anoCartaoPagamento}`;
        }

        setValidade(validade);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getInformationUser();
  }, []);

  useEffect(() => {
    // Checar pendência apenas uma vez ao entrar na página
    const checkPending = async () => {
      try {
        const res = await api.get("/compra/plano/pendente");
        const pendente = res?.data?.data?.pendente;
        setHasPendingPayment(pendente);
      } catch {}
    };
    checkPending();
  }, []);

  useEffect(() => {
    if (selectedPlan?.label !== "PLANO PRÉ-PAGO" && userCount > 0) {
      const cleanedValue = valuePerMonth.replace(/\./g, "").replace(",", ".");

      const numericValue = parseFloat(cleanedValue);

      const valuePerMonthWithUser = userCount * numericValue;

      const formattedValue = valuePerMonthWithUser.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      setResultValueUserMonth(formattedValue);
    } else {
      setResultValueUserMonth("0,00");
    }
  }, [userCount, valuePerMonth]);

  useEffect(() => {
    if (selectedPlan?.label === "PLANO PRÉ-PAGO" && revenues > 0) {
      const numericValue = parseFloat(
        valueRevenuesPrePagoWithNotDiscount.replace(/\./g, "").replace(",", ".")
      );

      const valuePrePagoWithUser = revenues * numericValue;

      const formattedValue = valuePrePagoWithUser.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      setResultValuePrepago(formattedValue);
    }
  }, [
    revenues,
    valueRevenuesPrePago,
    resultvalueUserMonth,
    cupom,
    valueRevenuesPrePagoWithNotDiscount,
  ]);

  const formatCPF = (value) => {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return value;
  };

  const validateCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "");

    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
      return false;
    }

    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(9))) {
      return false;
    }

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(10))) {
      return false;
    }

    return true;
  };

  // Arredonda valor para centavos terminando em 0 ou 5
  const roundCentsToZeroOrFive = (num) => {
    const cents = Math.round(num * 100);
    const last = cents % 10;
    const base = cents - last;
    let newCents;
    if (last > 5) {
      newCents = base + 10;
    } else if (last < 5) {
      newCents = base;
    } else {
      newCents = base + 5;
    }
    return newCents / 100;
  };

  const extractCurrencyNumber = (text) => {
    if (text === null || text === undefined) return 0;
    const str = String(text);

    const matchBr = str.match(/(\d{1,3}(?:\.\d{3})*|\d+),(\d{1,2})/);
    if (matchBr) {
      const normalized = matchBr[0].replace(/\./g, "").replace(",", ".");
      const num = Number(normalized);
      return Number.isFinite(num) ? num : 0;
    }

    const matchEn = str.match(/\d+(?:\.\d{1,2})?/);
    if (matchEn) {
      const num = Number(matchEn[0]);
      return Number.isFinite(num) ? num : 0;
    }

    return 0;
  };

  const calculateSubtotal = () => {
    const extractNumber = (text) => {
      if (text === null || text === undefined) return 0;
      const str = String(text);
      const match = str.match(/(\d{1,3}(?:\.\d{3})*|\d+),(\d{1,2})/);
      if (!match) return 0;
      const normalized = match[0].replace(/\./g, "").replace(",", ".");
      const num = Number(normalized);
      return isNaN(num) ? 0 : num;
    };

    const valueMonthNum = extractNumber(valueMonthDiscount);

    const valueForPayText = getFormattedValue();

    const valueForPayNum = extractNumber(valueForPayText);

    const diff = valueMonthNum - valueForPayNum;

    return diff.toFixed(2).replace(".", ",");
  };

  const formatRGRealtime = (value) => {
    let clean = value.toUpperCase().replace(/[^0-9A-Z]/g, "");

    clean = clean.slice(0, 10);

    const digits = clean.slice(0, 9);
    const lastChar = clean.slice(8);

    let formatted = digits;

    if (formatted.length >= 3) {
      formatted = `${formatted.slice(0, 2)}.${formatted.slice(2)}`;
    }
    if (formatted.length >= 7) {
      formatted = `${formatted.slice(0, 6)}.${formatted.slice(6)}`;
    }
    if (formatted.length >= 10) {
      formatted = `${formatted.slice(0, 10)}-${lastChar}`;
    } else if (lastChar) {
      formatted += `-${lastChar}`;
    }

    return formatted;
  };

  const validateRG = (rg) => {
    const rgLimpo = rg.replace(/[.,-\/]/g, "");

    const isValid = rgLimpo.length >= 6 && rgLimpo.length <= 9;

    return isValid;
  };

  const validatePhone = (phone) => {
    const onlyNumbers = phone.replace(/\D/g, "");

    return onlyNumbers.length === 10 || onlyNumbers.length === 11;
  };

  const formatCNPJ = (value) => {
    if (!value) return "";
    value = value.replace(/\D/g, "").slice(0, 14);
    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
    return value;
  };

  const validateCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/\D/g, "");
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    const digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0))) return false;

    length = length + 1;
    numbers = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1))) return false;

    return true;
  };

  const formatCPFOrCNPJ = (value) => {
    if (!value) return "";

    const cleaned = value.replace(/\D/g, "");
    return cleaned.length <= 11 ? formatCPF(value) : formatCNPJ(value);
  };

  const validateCPForCNPJ = (doc) => {
    doc = doc.replace(/\D/g, "");

    if (doc.length === 11) return validateCPF(doc);
    if (doc.length === 14) return validateCNPJ(doc);

    return false;
  };

  const formatCEP = (value) => {
    if (!value) return "";

    const onlyNumbers = value.replace(/\D/g, "");

    if (onlyNumbers.length <= 5) {
      return onlyNumbers;
    }
    return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(
      2,
      5
    )}-${onlyNumbers.slice(5, 8)}`;
  };

  const formatCEPForBackend = (cep) => {
    const cleaned = cep.replace(/\D/g, "");

    return cleaned.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
  };

  const validateCEP = (cep) => {
    const cleanedCEP = cep.replace(/\D/g, "");

    if (cleanedCEP.length !== 8) {
      return false;
    }

    if (/^(\d)\1+$/.test(cleanedCEP)) {
      return false;
    }

    return true;
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
    return regex.test(email.trim());
  };

  const formatCardNumber = (value) => {
    if (!value) return "";

    const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    const matches = v.match(/\d{4,16}/g);
    const match = (matches && matches[0]) || "";
    const parts = [];

    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
      return parts.join(" ");
    }
    return v;
  };

  const validateCardNumber = (number) => {
    const cleaned = number.replace(/\D/g, "");

    if (cleaned.length < 13 || cleaned.length > 19) {
      return false;
    }

    let sum = 0;
    let shouldDouble = false;

    for (let i = cleaned.length - 1; i >= 0; i--) {
      let digit = parseInt(cleaned.charAt(i));

      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
      shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
  };

  const formatExpiryDate = (value) => {
    let v = value.replace(/\D/g, "");

    if (v.length > 2) {
      v = v.substring(0, 2) + "/" + v.substring(2, 6);
    }

    return v;
  };

  const validateExpiryDate = (value) => {
    if (!value) return false;

    const [month, year] = value.split("/");

    if (!month || !year || month.length !== 2 || year.length !== 4) {
      return false;
    }

    const numericMonth = parseInt(month, 10);
    const numericYear = parseInt(year, 10);

    if (numericMonth < 1 || numericMonth > 12) {
      return false;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    if (
      numericYear < currentYear ||
      (numericYear === currentYear && numericMonth < currentMonth)
    ) {
      return false;
    }

    return true;
  };

  const formatCVV = (value) => {
    return value.replace(/\D/g, "").slice(0, 4);
  };

  const validateCVV = (value) => {
    return /^[0-9]{3,4}$/.test(value);
  };

  const extractMonthAndYear = (rawValue) => {
    const formatted = formatExpiryDate(rawValue);
    const [month, year] = formatted.split("/");
    return {
      month: month || "",
      year: year ? year.slice(-2) : "",
    };
  };

  const getCategoria = async () => {
    const response = await api.get("/info/categorias");

    const formattedCategoria = response.data.data.map((depto) => ({
      value: depto.id,
      label: depto.nome,
    }));

    setCategoriaOptions(formattedCategoria);
  };

  useEffect(() => {
    getCategoria();
  }, []);

  const tooltipResponsavel = (
    <div style={{ textAlign: "left", padding: "10px", maxWidth: "300px" }}>
      <ul style={{ margin: 0, padding: "0 0 0 20px", listStyleType: "disc" }}>
        <li>
          Marque esta opção se o usuário deve ser o profissional formalmente
          responsável pelas decisões técnicas do projeto/serviço.
        </li>
      </ul>
    </div>
  );

  const handleCopyDataUser = () => {
    setNameUserFaturamento(nameUser);
    setEmailUserFaturamento(emailUser);
    setPhoneUserFaturamento(phoneUser);
    setCargoUserFaturamento(cargoUser);
    setWorkSpaceFaturamento({
      value: workSpaceUser.value,
      label: workSpaceUser.label,
    });

    setErrorsFaturamento((prevErrors) => {
      const updatedErrors = {
        ...prevErrors,
        ...(nameUser !== "" && { nameUserFaturamento: false }),
        ...(emailUser !== "" && { emailUserFaturamento: false }),
        ...(phoneUser !== "" && { phoneUserFaturamento: false }),
        ...(cargoUser !== "" && { cargoUserFaturamento: false }),
        ...(workSpaceUser.value !== "" && {
          workSpaceFaturamento: false,
        }),
      };

      checkAllFaturamentoErrors(updatedErrors);
      return updatedErrors;
    });
  };

  const formatAndValidatePhone = (phone) => {
    const cleanedPhone = phone.replace(/\D/g, "");

    if (cleanedPhone.length !== 10 && cleanedPhone.length !== 11) {
      return null;
    }

    const ddd = cleanedPhone.substring(0, 2);
    const number = cleanedPhone.substring(2);

    const formattedPhone =
      number.length === 8
        ? `(${ddd}) ${number.substring(0, 4)}-${number.substring(4)}`
        : `(${ddd}) ${number.substring(0, 5)}-${number.substring(5)}`;

    return formattedPhone;
  };

  const handleCnpj = async (cnpj, card) => {
    if (card === "empresa") {
      try {
        const cnpjSemFormatacao = cnpj;

        if (cnpjSemFormatacao.length === 14) {
          const response = await api.get(
            `/helper/busca-cnpj/${cnpjSemFormatacao}`
          );

          if (response) {
            const dataEmpresa = response.data;

            setRazaoSocialEmpresa(dataEmpresa.nome ? dataEmpresa.nome : "");
            setNomeFantasiaEmpresa(
              dataEmpresa.fantasia ? dataEmpresa.fantasia : ""
            );

            const telefoneFormatado =
              dataEmpresa.telefone !== "(null) null" ||
              dataEmpresa.telefone !== "(null)" ||
              dataEmpresa.telefone !== "null" ||
              dataEmpresa.telefone !== "-"
                ? formatAndValidatePhone(dataEmpresa.telefone)
                : null;

            setTelefoneEmpresa(telefoneFormatado || "");

            setComplementoEmpresa(
              dataEmpresa.complemento ? dataEmpresa.complemento : ""
            );

            const cep = dataEmpresa.cep ? dataEmpresa.cep : "";
            const cepSemFormatacao = cep.replace(/\D/g, "");
            setCepEmpresa(cepSemFormatacao ? cepSemFormatacao : "");

            if (cepSemFormatacao) {
              fetchCep(cepSemFormatacao, "empresa");
            }

            setNumeroEmpresa(
              /^\d+$/.test(dataEmpresa.numero) ? dataEmpresa.numero : ""
            );

            setErrorsEmpresa((prevErrors) => ({
              ...prevErrors,
              ...(dataEmpresa.nome && { razaoSocialEmpresa: false }),
              ...(dataEmpresa.fantasia && { nomeFantasiaEmpresa: false }),
              ...(dataEmpresa.telefone && { telefoneEmpresa: false }),
              ...(dataEmpresa.cep && { cepEmpresa: false }),
              ...(dataEmpresa.numero && { numeroEmpresa: false }),
            }));
          }
        }
      } catch (error) {}
    } else {
      try {
        const cnpjSemFormatacao = cnpj;

        if (cnpjSemFormatacao.length === 14) {
          const response = await api.get(
            `/helper/busca-cnpj/${cnpjSemFormatacao}`
          );

          if (response) {
            const dataPagamento = response.data;

            const telefoneFormatado =
              dataPagamento.telefone !== "(null) null" ||
              dataPagamento.telefone !== "(null)" ||
              dataPagamento.telefone !== "null" ||
              dataPagamento.telefone !== "-"
                ? formatAndValidatePhone(dataPagamento.telefone)
                : null;

            const cpfCnpjEmpresaRaw = cpfCnpjEmpresa.replace(/\D/g, "");
            const cpfCnpjPagamentoRaw = cpfOrCnpjPagamento.replace(/\D/g, "");

            if (
              (cpfCnpjEmpresaRaw.length === 11 &&
                cpfCnpjPagamentoRaw === cpfCnpjEmpresaRaw) ||
              (cpfCnpjPagamentoRaw.length === 14 &&
                cpfCnpjPagamentoRaw === cpfCnpjEmpresaRaw)
            ) {
              setPhonePagamento(telefoneEmpresa);
              setComplementoPagamento(complementoEmpresa);
            } else {
              setPhonePagamento(telefoneFormatado || "");
              setComplementoPagamento(dataPagamento.complemento);
            }

            const cepSemFormatacao = dataPagamento.cep.replace(/\D/g, "");
            setCepPagamento(cepSemFormatacao);

            if (cepSemFormatacao) {
              fetchCep(cepSemFormatacao, "pagamento");
            }

            setNumeroPagamento(dataPagamento.numero);

            setErrorsPagamento((prevErrors) => ({
              ...prevErrors,
              ...(dataPagamento.telefone && { phonePagamento: false }),
              ...(dataPagamento.complemento && { complementoPagamento: false }),
              ...(dataPagamento.cep && { cepPagamento: false }),
              ...(dataPagamento.numero && { numeroPagamento: false }),
            }));
          }
        }
      } catch (error) {}
    }
  };

  const fetchCep = async (cep, formType = "empresa") => {
    try {
      const cepData = await buscaCep(cep);
      const { logradouro, bairro, localidade, uf, estado } = cepData;

      switch (formType) {
        case "empresa":
          if (logradouro) setEnderecoEmpresa(logradouro);
          if (bairro) setBairroEmpresa(bairro);
          setCidadeEmpresa(localidade);

          if (uf && estado) {
            setUfEmpresa({ value: uf, label: estado });
          }

          setErrorsEmpresa((prev) => ({
            ...prev,
            enderecoEmpresa: false,
            bairroEmpresa: false,
            cidadeEmpresa: false,
            ufEmpresa: false,
            cepEmpresa: false,
          }));
          break;

        case "pagamento":
          setEnderecoPagamento(logradouro);
          setBairroPagamento(bairro);
          setCidadePagamento(localidade);

          if (uf && estado) {
            setUFPagamento({ value: uf, label: estado });
          }

          setErrorsPagamento((prev) => ({
            ...prev,
            enderecoPagamento: false,
            bairroPagamento: false,
            cidadePagamento: false,
            ufPagamento: false,
            cepPagamento: false,
          }));
          break;

        default:
          break;
      }
    } catch (err) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(err),  
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });

      // Setar o erro de CEP conforme o formType
      if (formType === "empresa") {
        setErrorsEmpresa((prev) => ({
          ...prev,
          cepEmpresa: true,
        }));
      } else if (formType === "pagamento") {
        setErrorsPagamento((prev) => ({
          ...prev,
          cepPagamento: true,
        }));
      }
    }
  };

  useEffect(() => {
    validateDataPlan();
  }, [idPlanGridCard, userCount]);

  const validateDataPlan = () => {
    const userInfo = JSON.parse(localStorage.getItem("@userinfo"));
    const currentPlanId = userInfo?.contrato?.agro_plan_config?.agro_plan_id;

    if (Number(idPlanCard) === 0) {
      return false;
    }

    if (currentPlanId && Number(currentPlanId) === Number(idPlanCard)) {
      setErrorsPlan((prev) => {
        const updatedErrors = { ...prev, selectedPlan: true };
        checkPlanErrors(updatedErrors);
        return updatedErrors;
      });

      store.addNotification({
        title: "Erro!",
        message: "Não há possibilidade de atualizar o plano selecionado.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
      setIsConfirmLoading(false);

      setOpenAccordionKey(null);

      return false;
    }

    checkPlanErrors(false);

    const newErrorsPlan = {
      selectedPlan: !selectedPlan,
      userCount: !userCount || userCount <= 0,
      revenues: revenues ? revenues <= 0 : false,
    };

    setErrorsPlan(newErrorsPlan);

    const hasErrors = Object.values(newErrorsPlan).some(Boolean);

    return !hasErrors;
  };

  const handleDataPlano = async () => {
    const formatValue = (value) => {
      if (!value) return "0,00";

      const sanitized = value.toString().replace(/[^\d.,]/g, "");
      const withoutThousands = sanitized.replace(/\./g, "");

      return withoutThousands;
    };

    const selectedParcelasCount = Number(selectedParcelas?.value || 1);
    const isCreditCard = selectedMetod === "cartao_credito";
    const totalComJuros =
      isCreditCard && selectedParcelasCount > 1 && selectedParcelas?.total_juros
        ? selectedParcelas.total_juros
        : null;

    const payload = {
      qtd_documents: qtdDocuments,
      qtd_prescriptions:
        selectedPlan?.label === "PLANO PRÉ-PAGO" ? revenues : qtdPrescriptions,
      qtd_users: userCount,
      cupom: cupom ? cupom.toUpperCase() : "",
      // Total a pagar da tela, para todos os planos. No pre-pago o resultValuePrepago e
      // montado a partir do preco sem desconto, entao nao serve como valor a cobrar.
      valor_total_plano: formatValue(totalComJuros || getFormattedValue()),
      // Preco sem cupom. No pre-pago qtd_users e sempre 1, entao o total cheio serve de unitario.
      valor_unitario:
        selectedPlan?.label === "PLANO PRÉ-PAGO"
          ? resultValuePrepago
          : formatValue(fullValueAnual ? valueAnual : valueMonthNotDiscount),
      parcelas: selectedParcelas.value ? selectedParcelas.value : 1,
      grid_plano: idPlanGridCard,
      utm_campaign: urlParams?.utm_campaign ? urlParams.utm_campaign : 'orgânico',
      utm_id: urlParams?.utm_id ? urlParams.utm_id : "0",
      utm_medium: urlParams?.utm_medium ? urlParams.utm_medium : 'orgânico',
      utm_source: urlParams?.utm_source ? urlParams.utm_source : 'orgânico',
      button: urlParams?.button ? urlParams.button : "0",
    };

    try {
      const response = await api.post("/compra/plano", payload);
      if (response.status === 201) {
        setActiveAccordionUser(false);
        setStartValidationUser(true);
        return true;
      }
      store.addNotification({
        title: "Erro!",
        message: "Falha ao atualizar o plano",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return false;
    } catch (e) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(e, "ERRO-648 Falha ao atualizar o plano - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return false;
    }
  };

  useEffect(() => {
    if (openAccordionKey === null) {
      setActiveAccordionEmpresa(true);
      return;
    }

    const isValid = initialValidateDataUser();
    if (isValid === true && openAccordionKey === "user") {
      setActiveAccordionEmpresa(false);
    }
  }, [
    nameUser,
    emailUser,
    phoneUser,
    cargoUser,
    workSpaceUser,
    cpfUser,
    rgUser,
    openAccordionKey,
  ]);

  const initialValidateDataUser = () => {
    const newErrorsUser = {
      nameUser: !nameUser?.trim(),
      emailUser: !emailUser?.trim(),
      phoneUser: !phoneUser?.trim(),
      cargoUser: !cargoUser?.trim(),
      workSpaceUser: !workSpaceUser?.value,
      cpfUser: !cpfUser?.trim(),
      rgUser: !rgUser?.trim(),
    };

    const hasErrors = Object.values(newErrorsUser).some(Boolean);

    return !hasErrors;
  };

  const validateDataUser = async () => {
    const newErrorsUser = {
      nameUser: !nameUser?.trim(),
      emailUser: !emailUser?.trim() || !validateEmail(emailUser),
      phoneUser: !phoneUser?.trim() || !validatePhone(phoneUser),
      cargoUser: !cargoUser?.trim(),
      workSpaceUser: !workSpaceUser?.value,
      cpfUser: !cpfUser?.trim(),
      rgUser: !rgUser?.trim() || !validateRG(rgUser),
    };

    if (cpfUser?.trim()) {
      const resultadoCpf = await validadorCpfCnpj(cpfUser);
      newErrorsUser.cpfUser = !resultadoCpf.valido;
    }

    setErrorsUser(newErrorsUser);

    const hasErrors = Object.values(newErrorsUser).some(Boolean);

    if (hasErrors && !notificationShown.current) {
      store.addNotification({
        title: "Erro!",
        message: "Verifique todos os campos em vermelho antes de prosseguir",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });

      notificationShown.current = true;
    } else {
      notificationShown.current = false;
    }

    return !hasErrors;
  };

  const handleDataUser = async (isValidUser) => {
    if (isValidUser === true) {
      try {
        console.log("urlParams", urlParams)
        const payload = {
          ass_resp_contr_cargo: cargoUser,
          ass_resp_contr_cpf: formatCPF(cpfUser),
          ass_resp_contr_departamento: workSpaceUser.value,
          ass_resp_contr_email: emailUser,
          ass_resp_contr_nome_completo: nameUser,
          ass_resp_contr_rg: rgUser,
          ass_resp_contr_telefone: phoneUser,
          salvar_responsavel_tecnico: isResponsavelTecnico,
          utm_campaign: urlParams?.utm_campaign ? urlParams.utm_campaign : 'orgânico',
          utm_id: urlParams?.utm_id ? urlParams.utm_id : "0",
          utm_medium: urlParams?.utm_medium ? urlParams.utm_medium : 'orgânico',
          utm_source: urlParams?.utm_source ? urlParams.utm_source : 'orgânico',
          button: urlParams?.button ? urlParams.button : "0",
        };

        await api.post("/compra/responsavel", payload);

        setStartValidationEmpresa(true);
        setActiveAccordionEmpresa(false);

        return true;
      } catch (error) {}
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (startValidationEmpresa === true) {
      const isValid = initialValidateDataEmpresa();

      if (isValid === true) {
        setActiveAccordionFaturamento(false);
      }
    }
  }, [
    startValidationEmpresa,
    cpfCnpjEmpresa,
    nomeCompletoEmpresa,
    telefoneEmpresa,
    rgEmpresa,
    razaoSocialEmpresa,
    nomeFantasiaEmpresa,
    telefoneEmpresa,
    cepEmpresa,
    enderecoEmpresa,
    numeroEmpresa,
    complementoEmpresa,
    bairroEmpresa,
    cidadeEmpresa,
    ufEmpresa,
    inscricaoEstadualEmpresa,
    categoriaEmpresa,
  ]);

  const initialValidateDataEmpresa = () => {
    const tipoCompra = cpfCnpjEmpresa?.length === 11 ? "PF" : "PJ";

    const valueNumeroEmpresa = numeroEmpresa || "";

    const newErrors = {
      cpfCnpjEmpresa: !cpfCnpjEmpresa?.trim(),
      nomeCompletoEmpresa: tipoCompra === "PF" && !nomeCompletoEmpresa.trim(),
      rgEmpresa: tipoCompra === "PF" && !rgEmpresa.trim(),
      razaoSocialEmpresa: tipoCompra === "PJ" && !razaoSocialEmpresa.trim(),
      nomeFantasiaEmpresa: tipoCompra === "PJ" && !nomeFantasiaEmpresa.trim(),
      telefoneEmpresa: !telefoneEmpresa.trim(),
      cepEmpresa: !cepEmpresa.trim(),
      enderecoEmpresa: !enderecoEmpresa.trim(),
      numeroEmpresa: !(valueNumeroEmpresa || "").trim(),
      bairroEmpresa: !bairroEmpresa.trim(),
      cidadeEmpresa: !cidadeEmpresa.trim(),
      ufEmpresa: !ufEmpresa.value,
      inscricaoEstadualEmpresa:
        tipoCompra === "PJ" && !inscricaoEstadualEmpresa.trim(),
      categoriaEmpresa: !categoriaEmpresa.value,
    };

    const hasErrors = Object.values(newErrors).some(Boolean);

    return !hasErrors;
  };

  const validateDataEmpresa = async () => {
    const tipoCompra = cpfCnpjEmpresa.length === 11 ? "PF" : "PJ";

    const valueNumeroEmpresa = numeroEmpresa || "";

    const newErrors = {
      cpfCnpjEmpresa: !cpfCnpjEmpresa.trim(),
      nomeCompletoEmpresa: tipoCompra === "PF" && !nomeCompletoEmpresa.trim(),
      rgEmpresa:
        tipoCompra === "PF" && (!rgEmpresa.trim() || !validateRG(rgEmpresa)),
      razaoSocialEmpresa: tipoCompra === "PJ" && !razaoSocialEmpresa.trim(),
      nomeFantasiaEmpresa: tipoCompra === "PJ" && !nomeFantasiaEmpresa.trim(),
      telefoneEmpresa:
        !telefoneEmpresa.trim() || !validatePhone(telefoneEmpresa),
      cepEmpresa: !cepEmpresa.trim() || !validateCEP(cepEmpresa),
      enderecoEmpresa: !enderecoEmpresa.trim(),
      numeroEmpresa: !(valueNumeroEmpresa || "").trim(),
      bairroEmpresa: !bairroEmpresa.trim(),
      cidadeEmpresa: !cidadeEmpresa.trim(),
      ufEmpresa: !ufEmpresa.value,
      inscricaoEstadualEmpresa:
        tipoCompra === "PJ" && !inscricaoEstadualEmpresa.trim(),
      categoriaEmpresa: !categoriaEmpresa.value,
    };

    if (cpfCnpjEmpresa.trim()) {
      const resultadoDoc = await validadorCpfCnpj(cpfCnpjEmpresa);
      newErrors.cpfCnpjEmpresa = !resultadoDoc.valido;
    }

    setErrorsEmpresa(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    setAcordionEmpresaError(hasErrors);

    if (hasErrors && !notificationShown.current) {
      store.addNotification({
        title: "Erro!",
        message: "Verifique todos os campos em vermelho antes de prosseguir",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });

      notificationShown.current = true;
    } else {
      notificationShown.current = false;
    }

    return !hasErrors;
  };

  const handleDataEmpresa = async (isValidEmpresa) => {
    if (isValidEmpresa === true) {
      const tipoCompra = cpfCnpjEmpresa.length === 11 ? "PF" : "PJ";

      try {
        const payload = {
          tipo_compra: tipoCompra,
          cad_bairro: bairroEmpresa,
          cad_categoria: categoriaEmpresa.value,
          cad_cep: cepEmpresa,
          cad_cidade: cidadeEmpresa,
          cad_cpf_cnpj: formatCPFOrCNPJ(cpfCnpjEmpresa),
          cad_complemento: complementoEmpresa || "",
          cad_endereco: enderecoEmpresa,
          cad_estado: ufEmpresa.value,
          cad_ie: tipoCompra === "PJ" ? inscricaoEstadualEmpresa : rgEmpresa,
          cad_nome_fantasia:
            tipoCompra === "PJ" ? nomeFantasiaEmpresa : nomeCompletoEmpresa,
          cad_razao_social:
            tipoCompra === "PJ" ? razaoSocialEmpresa : nomeCompletoEmpresa,
          cad_numero: numeroEmpresa,
          cad_telefone: telefoneEmpresa,
          utm_campaign: urlParams?.utm_campaign ? urlParams.utm_campaign : 'orgânico',
          utm_id: urlParams?.utm_id ? urlParams.utm_id : "0",
          utm_medium: urlParams?.utm_medium ? urlParams.utm_medium : 'orgânico',
          utm_source: urlParams?.utm_source ? urlParams.utm_source : 'orgânico',
          button: urlParams?.button ? urlParams.button : "0",
        };

        await api.post("/compra/empresa", payload);

        setStartValidationFaturamento(true);

        return true;
      } catch (error) {}
    }
  };

  useEffect(() => {
    if (startValidationFaturamento === true) {
      const isValid = initialValidateDataFaturamento();

      if (isValid === true) {
        setActiveAccordionPagamento(false);
      }
    }
  }, [
    nameUserFaturamento,
    emailUserFaturamento,
    phoneUserFaturamento,
    cargoUserFaturamento,
    workSpaceFaturamento,
    numeroPedidoFaturamento,
  ]);

  const initialValidateDataFaturamento = () => {
    const valueUserFaturamento = nameUserFaturamento || "";
    const valueEmailUserFaturamento = emailUserFaturamento || "";
    const valuePhoneUserFaturamento = phoneUserFaturamento || "";
    const valueCargoUserFaturamento = cargoUserFaturamento || "";
    const valueWorkSpaceUserFaturamento = workSpaceFaturamento.value || "";

    const newErrors = {
      nameUserFaturamento: !valueUserFaturamento.trim(),
      emailUserFaturamento: !valueEmailUserFaturamento.trim(),
      phoneUserFaturamento: !valuePhoneUserFaturamento.trim(),
      cargoUserFaturamento: !valueCargoUserFaturamento.trim(),
      workSpaceFaturamento: !valueWorkSpaceUserFaturamento,
    };

    const hasErrors = Object.values(newErrors).some(Boolean);

    return !hasErrors;
  };

  const validateDataFaturamento = async () => {
    const valueUserFaturamento = nameUserFaturamento || "";
    const valueEmailUserFaturamento = emailUserFaturamento || "";
    const valuePhoneUserFaturamento = phoneUserFaturamento || "";
    const valueCargoUserFaturamento = cargoUserFaturamento || "";
    const valueWorkSpaceUserFaturamento = workSpaceFaturamento.value || "";

    const newErrors = {
      nameUserFaturamento: !valueUserFaturamento.trim(),
      emailUserFaturamento:
        !valueEmailUserFaturamento.trim() ||
        !validateEmail(valueEmailUserFaturamento),
      phoneUserFaturamento:
        !valuePhoneUserFaturamento.trim() ||
        !validatePhone(valuePhoneUserFaturamento),
      cargoUserFaturamento: !valueCargoUserFaturamento.trim(),
      workSpaceFaturamento: !valueWorkSpaceUserFaturamento,
    };

    setErrorsFaturamento(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    setAcordionFaturamentoError(hasErrors);

    if (hasErrors && !notificationShown.current) {
      store.addNotification({
        title: "Erro!",
        message: "Verifique todos os campos em vermelho antes de prosseguir",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });

      notificationShown.current = true;
    } else {
      notificationShown.current = false;
    }

    return !hasErrors;
  };

  const handleDataFaturamento = async () => {
    try {
      const payload = {
        fat_cargo: cargoUserFaturamento,
        fat_departamento: workSpaceFaturamento.value,
        fat_email_env_nfe: emailUserFaturamento,
        fat_num_ped_compra: numeroPedidoFaturamento || "",
        fat_resp_cont_pagar: nameUserFaturamento,
        fat_telefone: phoneUserFaturamento,
        utm_campaign: urlParams?.utm_campaign ? urlParams.utm_campaign : 'orgânico',
        utm_id: urlParams?.utm_id ? urlParams.utm_id : "0",
        utm_medium: urlParams?.utm_medium ? urlParams.utm_medium : 'orgânico',
        utm_source: urlParams?.utm_source ? urlParams.utm_source : 'orgânico',
        button: urlParams?.button ? urlParams.button : "0",
      };

      await api.post("/compra/faturamento", payload);

      setStartValidationPagamento(true);

      return true;
    } catch (error) {}
  };

  const handleDataPagamento = async () => {
    let newErrors = {};

    if (selectedMetod !== "boleto" && selectedMetod !== "pix") {
      newErrors = {
        parcelas: !selectedParcelas.value,
        cpfOrCnpjPagamento: !cpfOrCnpjPagamento.trim(),
        emailPagamento:
          !emailPagamento.trim() || !validateEmail(emailPagamento),
        phonePagamento:
          !phonePagamento.trim() || !validatePhone(phonePagamento),
        cepPagamento: !cepPagamento.trim() || !validateCEP(cepPagamento),
        enderecoPagamento: !enderecoPagamento.trim(),
        numeroPagamento: !numeroPagamento.trim(),
        complementoPagamento: false,
        bairroPagamento: !bairroPagamento.trim(),
        cidadePagamento: !cidadePagamento.trim(),
        ufPagamento: !ufPagamento.value,

        nomeTitularCartao: !nomeTitularCartao.trim(),
        numeroCartao: !numeroCartao.trim() || !validateCardNumber(numeroCartao),
        validade: !validade || !validateExpiryDate(formatExpiryDate(validade)),
        cvv: !cvv.trim() || !validateCVV(cvv),
      };

      if (cpfOrCnpjPagamento.trim()) {
        const resultadoDoc = await validadorCpfCnpj(cpfOrCnpjPagamento);
        newErrors.cpfOrCnpjPagamento = !resultadoDoc.valido;
      }
    } else {
      newErrors = {};
    }

    setErrorsPagamento(newErrors);

    const hasErrors = Object.values(newErrors).some((error) => error === true);

    if (selectedMetod === "boleto" || selectedMetod === "pix") {
      setAcordionPagamentoError(false);
    } else {
      setAcordionPagamentoError(hasErrors);
    }

    if (hasErrors) {
      return false;
    }

    const { month: expiracao_mes, year: expiracao_ano } =
      extractMonthAndYear(validade);

    try {
      if (selectedMetod === "boleto" || selectedMetod === "pix") {
        const planoOk = await handleDataPlano();
        if (!planoOk) {
          return false;
        }
        const payload = {
          tipo_pagamento: selectedMetod === "boleto" ? 1 : 2,

          nome_cartao: "",
          numero_cartao: "",
          expiracao_mes: "",
          expiracao_ano: "",
          ccv: "",
          nome_completo_cartao: "",
          email_cartao: "",
          cpf_cnpj_cartao: "",
          cep_cartao: "",
          endereco_cartao: "",
          complemento_cartao: "",
          fone_cartao: "",
          cel_cartao: "",
          numero_endereco_cartao: "",

          salvar_cartao: 0,
          termos: 1,

          utm_campaign: urlParams?.utm_campaign ? urlParams.utm_campaign : 'orgânico',
          utm_id: urlParams?.utm_id ? urlParams.utm_id : "0",
          utm_medium: urlParams?.utm_medium ? urlParams.utm_medium : 'orgânico',
          utm_source: urlParams?.utm_source ? urlParams.utm_source : 'orgânico',
          button: urlParams?.button ? urlParams.button : "0",
        };

        const response = await api.post("/compra/pagamento", payload);

        if (response.status === 201) {
          const valorTransacao = extractCurrencyNumber(getFormattedValue());
          const item =
            selectedPlan?.label === "PLANO PRÉ-PAGO"
              ? `${revenues} receitas`
              : `${selectedPlan?.label || "Plano"}${userCount ? ` - ${userCount} usuários` : ""}`;

          const orderId =
            numeroPedidoFaturamento ||
            response?.data?.data?.order_id ||
            response?.data?.data?.numero_pedido ||
            response?.data?.order_id ||
            response?.data?.id ||
            "";

          localStorage.setItem(
            PURCHASE_DATALAYER_KEY,
            JSON.stringify({
              valor_transacao: valorTransacao,
              moeda: "BRL",
              order_id: String(orderId),
              item,
            })
          );

          window.location.href = `/compra/sucesso/compra-${idPlanCard}?${selectedMetod}`;
        }
      } else {
        const planoOk = await handleDataPlano();
        if (!planoOk) {
          return false;
        }
        const payload = {
          parcelas: isAnnualPlanSelected ? selectedParcelas.value : 1,
          valor_parcelas: isAnnualPlanSelected
            ? brlToNumber(selectedParcelas.valor_parcela)
            : totalPlanValueForParcelas,
          tipo_pagamento: 3,
          nome_cartao: nomeTitularCartao.toUpperCase(),
          numero_cartao: formatCardNumber(numeroCartao),
          expiracao_mes: expiracao_mes,
          expiracao_ano: expiracao_ano,
          ccv: cvv,
          nome_completo_cartao: nameUser,
          email_cartao: emailPagamento,
          cpf_cnpj_cartao: formatCPFOrCNPJ(cpfOrCnpjPagamento),
          cep_cartao: formatCEPForBackend(cepPagamento),
          endereco_cartao: enderecoPagamento,
          complemento_cartao: complementoPagamento,
          fone_cartao: phonePagamento,
          cel_cartao: phonePagamento,
          numero_endereco_cartao: numeroPagamento,
          bairro_cartao: bairroPagamento,
          cidade_cartao: cidadePagamento,
          estado_cartao: ufPagamento.value,

          salvar_cartao: 1,
          termos: 1,

          utm_campaign: urlParams?.utm_campaign ? urlParams.utm_campaign : 'orgânico',
          utm_id: urlParams?.utm_id ? urlParams.utm_id : "0",
          utm_medium: urlParams?.utm_medium ? urlParams.utm_medium : 'orgânico',
          utm_source: urlParams?.utm_source ? urlParams.utm_source : 'orgânico',
          button: urlParams?.button ? urlParams.button : "0",
        };

        const response = await api.post("/compra/pagamento", payload);

        if (response.status === 201) {
          const valorTransacao = extractCurrencyNumber(getFormattedValue());
          const item =
            selectedPlan?.label === "PLANO PRÉ-PAGO"
              ? `${revenues} receitas`
              : `${selectedPlan?.label || "Plano"}${userCount ? ` - ${userCount} usuários` : ""}`;

          const orderId =
            numeroPedidoFaturamento ||
            response?.data?.data?.order_id ||
            response?.data?.data?.numero_pedido ||
            response?.data?.order_id ||
            response?.data?.id ||
            "";

          localStorage.setItem(
            PURCHASE_DATALAYER_KEY,
            JSON.stringify({
              valor_transacao: valorTransacao,
              moeda: "BRL",
              order_id: String(orderId),
              item,
            })
          );

          window.location.href = `/compra/sucesso/compra-${idPlanCard}?${selectedMetod}`;
        }
      }

      return true;
    } catch (err) {
      setIsConfirmLoading(false);
      store.addNotification({
        title: "Erro ao processar pagamento!",
        message: err?.response?.data?.message || err?.message || "Tente novamente ou entre em contato com o suporte.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }
  };

  const handlePendingModalUpdate = (resposta) => {
    if (resposta === 1) {
      // Usuário confirmou que deseja continuar mesmo com pendência
      setPendingConfirmedOnce(true);
      setShowPendingModal(false);
      setHasPendingPayment(false);
      // Reinvocar o submit para seguir o fluxo normal
      setTimeout(() => handleSubmit(true), 1000);
    } else {
      // Usuário cancelou
      setShowPendingModal(false);
      setIsConfirmLoading(false);
    }
  };

  const handleSubmit = async (force = false) => {
    if (!termosAceitos || !acordoAceito || errorsPlan.selectedPlan) {
      setIsConfirmLoading(false);
      return;
    }

    setIsConfirmLoading(true);
    saveGtmDataCompra();

    const isForced = force === true;

    // Se existir pendência e ainda não confirmada, abrir modal e interromper fluxo
    if (!isForced && hasPendingPayment === true) {
      setShowPendingModal(true);
      return;
    }

    try {
      const validatePagamento = async () => {
        if (selectedMetod === "boleto" || selectedMetod === "pix") {
          setAcordionPagamentoError(false);
          return true;
        }

        const safeValue = (value) => (value === undefined ? "" : value);

        const values = {
          parcelas: safeValue(selectedParcelas.value),
          cpfOrCnpjPagamento: safeValue(cpfOrCnpjPagamento),
          emailPagamento: safeValue(emailPagamento),
          phonePagamento: safeValue(phonePagamento),
          cepPagamento: safeValue(cepPagamento),
          enderecoPagamento: safeValue(enderecoPagamento),
          numeroPagamento: safeValue(numeroPagamento),
          bairroPagamento: safeValue(bairroPagamento),
          cidadePagamento: safeValue(cidadePagamento),
          ufPagamento: safeValue(ufPagamento?.value),
          nomeTitularCartao: safeValue(nomeTitularCartao),
          numeroCartao: safeValue(numeroCartao),
          validade: safeValue(validade),
          cvv: safeValue(cvv),
        };

        const newErrors = {
          parcelas: isAnnualPlanSelected ? !values.parcelas : false,
          cpfOrCnpjPagamento: !values.cpfOrCnpjPagamento.trim(),
          emailPagamento:
            !values.emailPagamento.trim() ||
            !validateEmail(values.emailPagamento),
          phonePagamento:
            !values.phonePagamento.trim() ||
            !validatePhone(values.phonePagamento),
          cepPagamento:
            !values.cepPagamento.trim() || !validateCEP(values.cepPagamento),
          enderecoPagamento: !values.enderecoPagamento.trim(),
          numeroPagamento: !values.numeroPagamento.trim(),
          complementoPagamento: false, // Campo opcional
          bairroPagamento: !values.bairroPagamento.trim(),
          cidadePagamento: !values.cidadePagamento.trim(),
          ufPagamento: !values.ufPagamento,
          nomeTitularCartao: !values.nomeTitularCartao.trim(),
          numeroCartao:
            !values.numeroCartao.trim() ||
            !validateCardNumber(values.numeroCartao),
          validade:
            !values.validade ||
            !validateExpiryDate(formatExpiryDate(values.validade)),
          cvv: !values.cvv.trim() || !validateCVV(values.cvv),
        };

        if (values.cpfOrCnpjPagamento.trim()) {
          const resultadoDoc = await validadorCpfCnpj(values.cpfOrCnpjPagamento);
          newErrors.cpfOrCnpjPagamento = !resultadoDoc.valido;
        }

        setErrorsPagamento(newErrors);

        const hasErrors = Object.values(newErrors).some(Boolean);

        setAcordionPagamentoError(hasErrors);

        if (hasErrors && !notificationShown.current) {
          store.addNotification({
            title: "Erro!",
            message:
              "Verifique todos os campos em vermelho antes de prosseguir",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 4000,
              onScreen: true,
            },
          });

          notificationShown.current = true;
        } else {
          notificationShown.current = false;
        }

        return !hasErrors;
      };

      const isPagamentoValid =
        selectedMetod === "cartao_credito" ? await validatePagamento() : true;

      if (!isPagamentoValid) {
        store.addNotification({
          title: "Erro!",
          message: "Verifique todos os campos em vermelho",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });
        setIsConfirmLoading(false);
        return;
      }

      await handleDataPagamento();
    } catch (error) {
      if (
        error?.response &&
        error.response.status === 422 &&
        error.config.url === "/compra/receita"
      ) {
        setErrorsPlan((prev) => ({
          ...prev,
          revenues: true,
        }));

        store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(
            error,
            "ERRO-649 Erro ao processar a receita. Verifique os dados e tente novamente - Tente novamente, se o erro persistir acione o suporte."
          ),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });
      }

      setIsConfirmLoading(false);
    }
  };

  useEffect(() => {
    const cleanedValueNotDiscount = valueMonth
      .replace(/\./g, "")
      .replace(",", ".");
    const valorSemDesconto = Number(cleanedValueNotDiscount);

    const cleanedValueWithDiscount = valueMonthWithDiscount
      .replace(/\./g, "")
      .replace(",", ".");
    const valorComDesconto = Number(cleanedValueWithDiscount);

    const diferencaMensal = (valorSemDesconto - valorComDesconto) * userCount;

    //Pre Pago
    const revenuesValueNotDiscount = valueRevenuesPrePagoWithNotDiscount
      .replace(/\./g, "")
      .replace(",", ".");
    const numberRevenuesNotDiscount = Number(revenuesValueNotDiscount);

    const revenuesValueWithDiscount = valueRevenuesPrePago
      .replace(/\./g, "")
      .replace(",", ".");
    const numberRevenuesValueWithDiscount = Number(revenuesValueWithDiscount);

    let resultadoFinal;

    if (cupom && messageCupom !== "") {
      if (selectedPlan.label !== "PLANO PRÉ-PAGO") {
        const baseCalculationValue =
          fullValueAnual && fullValueAnual !== "0,00"
            ? Number(valueAnualCalcWithMonth).toFixed(2)
            : valorComDesconto;

        const numericBaseValue = Number(baseCalculationValue);

        const annualReferenceValueStr =
          fullValueAnual && fullValueAnual !== "0,00"
            ? fullValueAnual.replace(/\./g, "").replace(",", ".")
            : valueMonth.replace(/\./g, "").replace(",", ".");

        const numericAnnualReference = Number(annualReferenceValueStr);

        const finalDiscountValue =
          fullValueAnual && fullValueAnual !== "0,00"
            ? numericBaseValue * userCount - numericAnnualReference
            : numericBaseValue * userCount - numericAnnualReference * userCount;

        const RemovedSimbols = Math.abs(finalDiscountValue);

        resultadoFinal = RemovedSimbols;
      } else {
        const baseCalculationValue = numberRevenuesNotDiscount;

        const numericBaseValue = Number(baseCalculationValue);

        const baseValueDiscount = revenuesValueWithDiscount;

        const numericBaseValueDiscount = Number(baseValueDiscount);

        const totalValue = numericBaseValue * revenues;

        const discountValue = numericBaseValueDiscount * revenues;

        const result = totalValue - discountValue;

        resultadoFinal = result;
      }
    } else {
      resultadoFinal = fullValueAnual
        ? diferencaMensal * discountMonths
        : diferencaMensal;
    }

    // Formatação do valor final
    const valorFormatado = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(resultadoFinal);

    setResultValuetotalWithDiscount(valorFormatado);
  }, [
    valueMonthNotDiscount,
    valueMonthWithDiscount,
    discountMonths,
    userCount,
    fullValueAnual,
    cupom,
    valueRevenuesPrePago,
    messageCupom,
    revenues,
    valueAnualCalcWithMonth,
  ]);

  useEffect(() => {
    const valorSemDesconto = Number(
      valueMonthNotDiscount.replace(/\./g, "").replace(",", ".")
    );

    const calculate = valorSemDesconto * userCount;

    const formated = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(calculate);

    setValueMonthDiscount(formated);
  }, [valueMonthNotDiscount, userCount]);

  const checkAndCopyUserData = () => {
    const cpfUserRaw = (cpfUser || "").replace(/\D/g, "");
    const cpfCnpjEmpresaRaw = cpfCnpjEmpresa?.replace(/\D/g, "");

    if (cpfUserRaw.length === 11 && cpfUserRaw === cpfCnpjEmpresaRaw) {
      setNomeCompletoEmpresa(nameUser);
      setTelefoneEmpresa(phoneUser);
      setRgEmpresa(rgUser);

      setErrorsEmpresa((prev) => ({
        ...prev,
        nomeCompletoEmpresa: false,
        telefoneEmpresa: false,
        rgEmpresa: false,
      }));

      return true;
    }

    return false;
  };

  const checkAndCopyEmpresaData = () => {
    const cpfCnpjEmpresaRaw = cpfCnpjEmpresa.replace(/\D/g, "");
    const cpfCnpjPagamentoRaw = cpfOrCnpjPagamento.replace(/\D/g, "");

    if (
      (cpfCnpjEmpresaRaw.length === 11 &&
        cpfCnpjPagamentoRaw === cpfCnpjEmpresaRaw) ||
      (cpfCnpjPagamentoRaw.length === 14 &&
        cpfCnpjPagamentoRaw === cpfCnpjEmpresaRaw)
    ) {
      const cepSemFormatacao = cepEmpresa.replace(/\D/g, "");

      setEmailPagamento(emailUser);
      setPhonePagamento(telefoneEmpresa);
      setCepPagamento(cepEmpresa);
      setNumeroPagamento(numeroEmpresa);
      setComplementoPagamento(complementoEmpresa);

      setErrorsPagamento((prev) => ({
        ...prev,
        emailPagamento: false,
        phonePagamento: false,
        cepPagamento: false,
        numeroPagamento: false,
        complementoPagamento: false,
      }));

      if (cepSemFormatacao.length === 8) {
        fetchCep(cepSemFormatacao, "pagamento");
      }

      return true;
    }

    return false;
  };

  const handleTermosClick = () => {
    setShowTermos(true);
  };

  const handlePoliticaClick = () => {
    setShowPolitica(true);
  };

  function handleKeyDownAllowCopyPaste(e) {
    if (
      (e.ctrlKey &&
        (e.key === "v" || e.key === "V" || e.key === "c" || e.key === "C")) ||
      (e.metaKey &&
        (e.key === "v" || e.key === "V" || e.key === "c" || e.key === "C"))
    ) {
      return;
    }
    if (!/[0-9]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)) {
      e.preventDefault();
    }
  }

  useEffect(() => {
    const hasUserErrors = Object.values(errorsUser).some(Boolean);
    setAcordionUserError(hasUserErrors);
  }, [errorsUser]);

  const checkPlanErrors = (currentErrors) => {
    const hasNoErrors = !Object.values(currentErrors).some(Boolean);

    setAcordionPlanError(!hasNoErrors);
  };

  const checkAllUserErrors = (currentErrors) => {
    const hasNoErrors = !Object.values(currentErrors).some(Boolean);
    setAcordionUserError(!hasNoErrors);
  };

  const checkAllEmpresaErrors = (currentErrors) => {
    const hasNoErrors = !Object.values(currentErrors).some(Boolean);
    setAcordionEmpresaError(!hasNoErrors);
  };

  const checkAllFaturamentoErrors = (currentErrors) => {
    const hasNoErrors = !Object.values(currentErrors).some(Boolean);
    setAcordionFaturamentoError(!hasNoErrors);
  };

  const checkAllPagamentoErrors = (currentErrors) => {
    const hasNoErrors = !Object.values(currentErrors).some(Boolean);
    setAcordionPagamentoError(!hasNoErrors);
  };

  const formatCurrency = (value) => {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  useEffect(() => {
    setSelectedMetod("pix");
  }, [selectedPlan]);

  const handleAccordionToggle = async (accordionKey) => {
    let canProceed = true;

    switch (openedAccordion) {
      case "user":
        const isValidUser = await validateDataUser();

        if (isValidUser) {
          await handleDataUser(isValidUser);
        } else {
          canProceed = false;
        }
        break;
      case "empresa":
        const isValidEmpresa = await validateDataEmpresa();

        if (isValidEmpresa) {
          await handleDataEmpresa(isValidEmpresa);
        } else {
          canProceed = false;
        }
        break;
      case "faturamento":
        const isValidFaturamento = await validateDataFaturamento();

        if (isValidFaturamento) {
          await handleDataFaturamento(isValidFaturamento);
        } else {
          canProceed = false;
        }
        break;
      default:
        break;
    }

    if (canProceed) {
      setOpenedAccordion(accordionKey);
    }
  };

  const allFieldsValid = () => {
    const valueUserFaturamento = nameUserFaturamento || "";
    const valueEmailUserFaturamento = emailUserFaturamento || "";
    const valuePhoneUserFaturamento = phoneUserFaturamento || "";
    const valueCargoUserFaturamento = cargoUserFaturamento || "";
    const valueWorkSpaceUserFaturamento = workSpaceFaturamento.value || "";

    const camposInvalidos = {
      nameUserFaturamento: !valueUserFaturamento.trim(),
      emailUserFaturamento: !valueEmailUserFaturamento.trim(),
      phoneUserFaturamento: !valuePhoneUserFaturamento.trim(),
      cargoUserFaturamento: !valueCargoUserFaturamento.trim(),
      workSpaceFaturamento: !valueWorkSpaceUserFaturamento,
    };

    const existeCampoInvalido = Object.values(camposInvalidos).some(Boolean);

    if (!existeCampoInvalido) {
      setActiveAccordionPagamento(false);
    }
  };

  const getFormattedValue = () => {
    if (
      selectedPlan?.label === "PLANO PRÉ-PAGO" &&
      valueRevenuesPrePago &&
      valueRevenuesPrePago !== "0,00"
    ) {
      const numericValue = parseFloat(valueRevenuesPrePago.replace(",", "."));
      const totalValue = numericValue * revenues;

      const formattedValue = totalValue.toFixed(2).replace(".", ",");

      const ret = `${formatCurrency(formattedValue)}`;
  
      return ret;
    }
    if (fullValueAnual && fullValueAnual !== "0,00") {
      const ret = `${formatCurrency(fullValueAnual)} /ano`;
      return ret;
    }

    if (cupom) {
      if (
        valuePerMonth &&
        valuePerMonth !== "0,00" &&
        selectedPlan?.label !== "PLANO PRÉ-PAGO"
      ) {
        let suffix = "";

        if (cupom === "BEMVINDO") {
          const monthlySuffix = fullValueAnual ? "" : "";
          suffix = monthlySuffix;
        } else {
          const monthlySuffix =
            fullValueAnual && fullValueAnual !== "0,00" ? "/ano" : "/mês";
          suffix = monthlySuffix;
        }

        const basePerMonth = cupomRecorrencia === 'ANUAL' ? valueMonthNotDiscount : valuePerMonth;
        const numericValue = parseFloat(basePerMonth.replace(",", "."));

        const totalValue = numericValue * userCount;

        const formattedValue = totalValue.toFixed(2).replace(".", ",");

        const ret = `${formattedValue} ${suffix}`;
        return ret;
      }
    } else {
      if (
        valuePerMonth &&
        valuePerMonth !== "0,00" &&
        selectedPlan?.label !== "PLANO PRÉ-PAGO"
      ) {
        const monthlySuffix =
          fullValueAnual && fullValueAnual !== "0,00" ? "/ano" : "/mês";

        const numericValue = parseFloat(valuePerMonth.replace(",", "."));

        const totalValue = numericValue * userCount;
        const roundedTotal = roundCentsToZeroOrFive(totalValue);

        const formattedValue = roundedTotal.toFixed(2).replace(".", ",");

        const ret = `${formattedValue} ${monthlySuffix}`;
        return ret;
      } else {
        if (
          valuePerMonth &&
          valuePerMonth !== "0,00" &&
          selectedPlan?.label !== "PLANO PRÉ-PAGO"
        ) {
          const monthlySuffix =
            fullValueAnual && fullValueAnual !== "0,00" ? "/ano" : "/mês";

          const numericValue = parseFloat(valuePerMonth.replace(",", "."));

          const totalValue = numericValue * userCount;
          const roundedTotal = roundCentsToZeroOrFive(totalValue);
        }

        if (
          resultvalueUserMonth &&
          resultvalueUserMonth !== "0,00" &&
          selectedPlan?.label !== "PLANO PRÉ-PAGO"
        ) {
          const monthlySuffix =
            fullValueAnual && fullValueAnual !== "0,00" ? "/ano" : "/mês";
          const ret = `${formatCurrency(
            resultvalueUserMonth
          )} ${monthlySuffix}`;
          return ret;
        }
      }

      return "0,00";
    }
  };

  const formattedValue = () => {
    if (fullValueAnual && fullValueAnual !== "0,00") {
      return `${formatCurrency(fullValueAnual)}`;
    }

    if (cupom) {
      if (
        valuePerMonth &&
        valuePerMonth !== "0,00" &&
        selectedPlan?.label !== "PLANO PRÉ-PAGO"
      ) {
        const monthlySuffix =
          fullValueAnual && fullValueAnual !== "0,00" ? "" : "/mês";

        const numericValue = parseFloat(valuePerMonth.replace(",", "."));

        const totalValue = numericValue * userCount;

        const formattedValue = totalValue.toFixed(2).replace(".", ",");

        setResultValueMonth(formattedValue);

        return `${formattedValue} ${monthlySuffix}`;
      }
    } else {
      if (
        resultvalueUserMonth &&
        resultvalueUserMonth !== "0,00" &&
        selectedPlan?.label !== "PLANO PRÉ-PAGO"
      ) {
        const monthlySuffix = !cupom || !messageCupom ? "/mês" : "";

        setResultValueMonth(resultvalueUserMonth);

        return `${formatCurrency(resultvalueUserMonth)} ${monthlySuffix}`;
      }

      if (
        valuePerMonth &&
        valuePerMonth !== "0,00" &&
        selectedPlan?.label !== "PLANO PRÉ-PAGO"
      ) {
        const monthlySuffix = !cupom || !messageCupom ? "/mês" : "";

        const numericValue = parseFloat(valuePerMonth.replace(",", "."));

        const totalValue = numericValue * userCount;

        const formattedValue = totalValue.toFixed(2).replace(".", ",");

        setResultValueMonth(formattedValue);

        return `${formattedValue} ${monthlySuffix}`;
      }
    }

    if (resultValuePrepago && resultValuePrepago !== "0,00") {
      setResultValueMonth(resultValuePrepago);
      return `${formatCurrency(resultValuePrepago)}`;
    }

    return "0,00";
  };

  useEffect(() => {
    formattedValue();
  }, [
    fullValueAnual,
    valuePerMonth,
    resultvalueUserMonth,
    resultValuePrepago,
    cupom,
    messageCupom,
    userCount,
    selectedPlan?.label,
  ]);

  const getValueCalcWithMonth = () => {
    if (fullValueAnual && fullValueAnual !== "0,00") {
      const numericValue = parseFloat(valueMonth.replace(",", "."));

      const totalValue = userCount
        ? numericValue * 12 * userCount
        : numericValue * 12;

      return formatCurrency(totalValue);
    } else {
      const numericValue = parseFloat(valueMonth.replace(",", "."));

      const totalValue = numericValue * userCount;

      return formatCurrency(totalValue);
    }
  };

  // Converte valores em formato BRL (ex.: "2.206,80") para número (2206.80)
  const brlToNumber = (value) => {
    if (typeof value === "number") return value;
    if (value === null || value === undefined) return 0;
    const str = String(value).trim();
    if (!str) return 0;
    const sanitized = str.replace(/[^\d.,-]/g, "");
    const normalized = sanitized.replace(/\./g, "").replace(",", ".");
    const num = Number(normalized);
    return isNaN(num) ? 0 : num;
  };

  const extractTotalValueFromFormattedText = (text) => {
    if (!text) return 0;
    const str = String(text);
    const match = str.match(/\d[\d.]*,\d{2}/);
    if (match && match[0]) {
      return brlToNumber(match[0]);
    }
    return brlToNumber(str);
  };

  const totalPlanValueForParcelas = useMemo(() => {
    return extractTotalValueFromFormattedText(getFormattedValue());
  }, [
    fullValueAnual,
    cupom,
    valuePerMonth,
    userCount,
    selectedPlan?.label,
    resultvalueUserMonth,
    valueRevenuesPrePago,
    revenues,
  ]);

  const isAnnualPlanSelected =
    fullValueAnual && fullValueAnual !== "0,00" ? true : false;

  useEffect(() => {
    if (!isAnnualPlanSelected) {
      setParcelasOptions([]);
      setSelectedParcelas({
        value: 1,
        label: "1x",
        valor_parcela: "",
        total_juros: "",
      });
      setErrorsPagamento((prev) => {
        const updatedErrors = { ...prev, parcelas: false };
        checkAllPagamentoErrors(updatedErrors);
        return updatedErrors;
      });
      return;
    }
    if (!totalPlanValueForParcelas || totalPlanValueForParcelas <= 0) return;

    const timeoutId = setTimeout(() => {
      (async () => {
        const raw = await postValueParcelas(totalPlanValueForParcelas);

        const data = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.data)
            ? raw.data
            : Array.isArray(raw?.data?.data)
              ? raw.data.data
              : null;

        if (!Array.isArray(data)) {
          setParcelasOptions([]);
          return;
        }

        setParcelasOptions(
          data
            .filter((item) => item && item.parcelas)
            .map((item) => ({
              value: item.parcelas,
              total_juros: item.total_juros,
              valor_parcela: item.valor_parcela,
              label: `${item.parcelas}x de ${item.valor_parcela} - ${
                Number(item.parcelas) === 1
                  ? `Total sem juros ${item.total_juros}`
                  : `Total c/ juros ${item.total_juros}`
              }`,
            }))
        );
      })();
    }, 250);

    return () => clearTimeout(timeoutId);
  }, [totalPlanValueForParcelas, isAnnualPlanSelected]);

  const postValueParcelas = async (value) => {
    try {
      const payload = {
        value: new Intl.NumberFormat("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
          .format(Number(value))
          .replace(/\./g, ""),
      };

      const response = await api.post("/compra/parcelas", payload);
      return response?.data;
    } catch {
      return null;
    }
  };

  const getValueDiscountAnual = () => {
    const numericValue = parseFloat(valueMonth.replace(",", "."));

    const totalValuForMonth = userCount
      ? numericValue * 12 * userCount
      : numericValue * 12;

    const fullValueAnualNumber = brlToNumber(fullValueAnual);

    const diffValue = totalValuForMonth - fullValueAnualNumber;

    return formatCurrency(diffValue);
  };

  const getValueCalcPrePago = () => {
    const numericValue = parseFloat(
      valueRevenuesPrePagoWithNotDiscount.replace(",", ".")
    );

    const totalValue = numericValue * revenues;

    return formatCurrency(totalValue);
  };

  useEffect(() => {
    if (fullValueAnual && cupom) {
      const numericValue = parseFloat(valueMonth.replace(",", "."));

      const totalValue = numericValue * 12;

      setValueAnualCalcWithMonth(totalValue);
    }
  }, [valueMonth, cupom, fullValueAnual]);

  useEffect(() => {
    if (selectedPlan?.label === "PLANO BASIC") {
      setUserCount(1);
    }
  }, [selectedPlan]);

  //Função que recarrega a página se tiver utm "cupom"
  useEffect(() => {
    // Verificar se já recarregou a página para o utm_cupom
    const hasReloadedForCupom = localStorage.getItem("@CupomReloaded");

    // Verificar se existe o parâmetro utm_cupom na URL
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const utmCupom = params.get("cupom");

    // Se tem utm_cupom e ainda não recarregou a página
    if (utmCupom && hasReloadedForCupom !== "true") {
      // Marcar que já recarregou para não recarregar novamente
      localStorage.setItem("@CupomReloaded", "true");
      // Recarregar a página
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    const hasReloadedForCupom = localStorage.getItem("@PlanReloaded");

    if (hasReloadedForCupom === "true") {
      localStorage.setItem("@PlanReloaded", "false");
      window.location.reload();
    }
  }, []);

  return (
    <S.Container>
      <HeaderV2 title="Detalhes da compra" />

      <S.Wrapper>
        <AcordionCardSimulation
          hasErrorSelect={errorsPlan.selectedPlan}
          hasErrorUsers={errorsPlan.userCount}
          hasErrorRevenues={errorsPlan.revenues}
          onPlanSelected={setSelectedPlan}
          onUsersCountChanged={(value) => {
            if (selectedPlan?.label === "PLANO BASIC") {
              setUserCount(1);
            } else {
              setUserCount(value);
            }
          }}
          onCouponChanged={setCupom}
          onRevenuesChanged={setRevenues}
          onValuePerMonthChanged={setValuePerMonth}
          onValueRevenuesPrePagoChanged={setValueRevenuesPrePago}
          onValueRevenuesPrePagoWithNotDiscount={
            setValueRevenuesPrePagoWithNotDiscount
          }
          onMessageCupomChanged={setMessageCupom}
          onCupomRecorrenciaChanged={setCupomRecorrencia}
          onFullValueMonthNotDiscountChanged={setValueMonthNotDiscount}
          onFullValueMonthWithDiscountChanged={setValueMonthWithDiscount}
          onFullValueAnual={setFullValueAnual}
          onValueAnual={setValueAnual}
          onValueMonth={setValueMonth}
          onFullValueNotDiscountAnual={setValueTotalWithDiscount}
          onIdPlanGridCard={setIdPlanGridCard}
          onIdPlanCard={setIdPlanCard}
          acordionError={acordionPlanError}
          onDiscountMonths={setDiscountMonths}
          onQtdDocuments={setQtdDocuments}
          onQtdPrescriptions={setQtdPrescriptions}
          isUserCountDisabled={selectedPlan?.label === "PLANO BASIC"}
        />

        <AcordionCard
          title="Dados do usuário"
          isOpen={openAccordionKey === "user"}
          hasError={acordionUserError}
          hasBlock={activeAccordionUser}
          onToggle={(key) => {
            setOpenAccordionKey(key);
            handleAccordionToggle(key);
          }}
          accordionKey="user"
        >
          <S.ContainerInputs>
            <S.ContainerForm>
              <InputV3
                id="nome_usuario"
                type="text"
                label="Nome completo"
                floatingLabelWithAsterisk="Nome completo"
                value={nameUser}
                onChange={(e) => {
                  setNameUser(e.target.value);

                  setErrorsUser((prev) => {
                    const updatedErrors = { ...prev, nameUser: false };
                    checkAllUserErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                onBlur={saveGtmDataCompra}
                hasError={errorsUser.nameUser}
                handleClear={() => {
                  setNameUser("");
                }}
              />

              <InputV3
                id="email_usuario"
                type="text"
                label="E-mail"
                floatingLabelWithAsterisk="E-mail"
                value={emailUser}
                onChange={(e) => {
                  setEmailUser(e.target.value);

                  setErrorsUser((prev) => {
                    const updatedErrors = { ...prev, emailUser: false };
                    checkAllUserErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                onBlur={saveGtmDataCompra}
                isDisabled={true}
                hasError={errorsUser.emailUser}
                handleClear={() => {
                  setEmailUser("");
                }}
              />

              <InputV3
                id="telefonecelular_usuario"
                type="telefone/celular"
                label="Telefone/Celular"
                floatingLabelWithAsterisk="Telefone/Celular"
                value={phoneUser}
                onChange={(e) => {
                  setPhoneUser(e.target.value);

                  setErrorsUser((prev) => {
                    const updatedErrors = { ...prev, phoneUser: false };
                    checkAllUserErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                onBlur={saveGtmDataCompra}
                hasError={errorsUser.phoneUser}
                handleClear={() => {
                  setPhoneUser("");
                }}
              />

              <InputV3
                id="cargo"
                type="text"
                label="Cargo"
                floatingLabelWithAsterisk="Cargo"
                value={cargoUser}
                onChange={(e) => {
                  setCargoUser(e.target.value);

                  setErrorsUser((prev) => {
                    const updatedErrors = { ...prev, cargoUser: false };
                    checkAllUserErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                hasError={errorsUser.cargoUser}
                handleClear={() => {
                  setCargoUser("");
                }}
              />

              <InputV3
                id="local_de_trabalho"
                type="select"
                typeValueSelect="number"
                floatingLabelWithAsterisk="Local de trabalho"
                value={workSpaceUser.label}
                onChange={(selectedOption) => {
                  setWorkSpaceUser({
                    value: selectedOption.value,
                    label: selectedOption.label,
                  });

                  setErrorsUser((prev) => {
                    const updatedErrors = { ...prev, workSpaceUser: false };
                    checkAllUserErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                options={workSpaceOptions}
                hasError={errorsUser.workSpaceUser}
                floatingValue={workSpaceUser.label}
              />

              <InputV3
                id="CPF"
                type="text"
                label="CPF"
                floatingLabelWithAsterisk="CPF"
                value={formatCPF(cpfUser)}
                onChange={async (e) => {
                  const rawValue = e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 11);
                  setCpfUser(rawValue);

                  setErrorsUser((prev) => {
                    const updatedErrors = { ...prev, cpfUser: false };
                    checkAllUserErrors(updatedErrors);
                    return updatedErrors;
                  });

                  if (rawValue.length === 11) {
                    const checkId = ++cpfUserCheckRef.current;
                    const resultado = await validadorCpfCnpj(rawValue);
                    if (checkId !== cpfUserCheckRef.current) return; // usuário já digitou algo novo, descarta resposta desatualizada

                    if (!resultado.valido) {
                      setErrorsUser((prev) => ({
                        ...prev,
                        cpfUser: true,
                      }));

                      store.addNotification({
                        title: "CPF inválido!",
                        message: resultado.erro || "Por favor, digite um CPF válido.",
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                          duration: 4000,
                          onScreen: true,
                        },
                      });
                    }
                  }
                }}
                onKeyDown={handleKeyDownAllowCopyPaste}
                hasError={errorsUser.cpfUser}
                maxLength={14}
                handleClear={() => {
                  setCpfUser("");
                }}
              />

              <InputV3
                id="RG"
                type="text"
                label="RG"
                floatingLabelWithAsterisk="RG"
                value={rgUser}
                onChange={(e) => {
                  const input = e.target.value;
                  const formatted = formatRGRealtime(input);

                  setRgUser(formatted);

                  setErrorsUser((prev) => {
                    const updatedErrors = { ...prev, rgUser: false };
                    checkAllUserErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                hasError={errorsUser.rgUser}
                maxLength={12}
                handleClear={() => {
                  setRgUser("");
                }}
              />

              {/* <S.ContainerInputCheckboxCenter>
                <input
                  type="checkbox"
                  id="ResponsavelTecnico"
                  name="ResponsavelTecnico"
                  checked={isResponsavelTecnico}
                  onChange={(e) => setIsResponsavelTecnico(e.target.checked)}
                />

                <S.ContainerTextWithInfo>
                  <BodyP color={theme.colors.gray.Cinza_2}>
                    Cadastrar este usuário como <b>Responsável Técnico</b>
                  </BodyP>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Tooltip
                      content={tooltipResponsavel}
                      animation="fade"
                      delay={[100, 100]}
                      arrow={true}
                      theme="light"
                      placement="bottom"
                    >
                      <img src={IconInfoBlack} alt="" />
                    </Tooltip>
                  </div>
                </S.ContainerTextWithInfo>
              </S.ContainerInputCheckboxCenter> */}
            </S.ContainerForm>
          </S.ContainerInputs>
        </AcordionCard>

        <AcordionCard
          title="Dados da empresa"
          isOpen={openAccordionKey === "empresa"}
          hasError={acordionEmpresaError}
          hasBlock={activeAccordionEmpresa}
          onToggle={(key) => {
            setOpenAccordionKey(key);
            handleAccordionToggle(key);
          }}
          accordionKey="empresa"
        >
          <S.ContainerInputs>
            <S.ContainerForm>
              <InputV3
                id="CPF/CNPJ"
                type="text"
                label="CPF/CNPJ"
                floatingLabelWithAsterisk="CPF/CNPJ"
                value={formatCPFOrCNPJ(cpfCnpjEmpresa)}
                onChange={async (e) => {
                  const rawValue = e.target.value.replace(/\D/g, "");
                  setCpfOrCnpjEmpresa(rawValue);
                  setGetCpfOrCnpjEmpresa(rawValue);

                  setErrorsEmpresa((prev) => {
                    const updatedErrors = { ...prev, cpfCnpjEmpresa: false };
                    checkAllEmpresaErrors(updatedErrors);
                    return updatedErrors;
                  });

                  if (rawValue.length === 11 || rawValue.length === 14) {
                    const checkId = ++cpfCnpjEmpresaCheckRef.current;
                    const resultado = await validadorCpfCnpj(rawValue);
                    if (checkId !== cpfCnpjEmpresaCheckRef.current) return; // usuário já digitou algo novo, descarta resposta desatualizada

                    if (resultado.valido) {
                      setShowOtherFields(true);
                    } else {
                      setErrorsEmpresa((prev) => ({
                        ...prev,
                        cpfCnpjEmpresa: true,
                      }));

                      store.addNotification({
                        title: "CPF/CNPJ inválido!",
                        message: resultado.erro || "Por favor, digite um CPF ou CNPJ válido.",
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                          duration: 4000,
                          onScreen: true,
                        },
                      });
                    }
                  }
                }}
                onBlur={() => {
                  handleCnpj(cpfCnpjEmpresa, "empresa");
                  checkAndCopyUserData();
                }}
                onKeyDown={handleKeyDownAllowCopyPaste}
                inputMode="numeric"
                maxLength={18}
                hasError={errorsEmpresa.cpfCnpjEmpresa}
                handleClear={() => {
                  setCpfOrCnpjEmpresa("");
                }}
              />

              {showOtherFields && (
                <S.ContainerInputs>
                  {formatCPFOrCNPJ(cpfCnpjEmpresa)?.length === 14 ? (
                    <S.ContainerForm>
                      <InputV3
                        id="nome_completo"
                        type="text"
                        label="Nome completo"
                        floatingLabelWithAsterisk="Nome completo"
                        value={nomeCompletoEmpresa}
                        onChange={(e) => {
                          setNomeCompletoEmpresa(e.target.value);

                          setErrorsEmpresa((prev) => {
                            const updatedErrors = {
                              ...prev,
                              nomeCompletoEmpresa: false,
                            };
                            checkAllEmpresaErrors(updatedErrors);
                            return updatedErrors;
                          });
                        }}
                        hasError={errorsEmpresa.nomeCompletoEmpresa}
                        handleClear={() => {
                          setNomeCompletoEmpresa("");
                        }}
                      />

                      <InputV3
                        id="Telefone/Celular"
                        type="text"
                        label="Telefone/Celular"
                        floatingLabelWithAsterisk="Telefone/Celular"
                        value={telefoneEmpresa}
                        onChange={(e) => {
                          setTelefoneEmpresa(e.target.value);

                          setErrorsEmpresa((prev) => {
                            const updatedErrors = {
                              ...prev,
                              telefoneEmpresa: false,
                            };
                            checkAllEmpresaErrors(updatedErrors);
                            return updatedErrors;
                          });
                        }}
                        hasError={errorsEmpresa.telefoneEmpresa}
                        handleClear={() => {
                          setTelefoneEmpresa("");
                        }}
                      />

                      <InputV3
                        id="rg"
                        type="text"
                        label="RG"
                        floatingLabelWithAsterisk="RG"
                        value={rgEmpresa}
                        onChange={(e) => {
                          const input = e.target.value;
                          const formatted = formatRGRealtime(input);

                          setRgEmpresa(formatted);

                          setErrorsEmpresa((prev) => {
                            const updatedErrors = { ...prev, rgEmpresa: false };
                            checkAllEmpresaErrors(updatedErrors);
                            return updatedErrors;
                          });
                        }}
                        hasError={errorsEmpresa.rgEmpresa}
                        maxLength={12}
                        handleClear={() => {
                          setRgEmpresa("");
                        }}
                      />
                    </S.ContainerForm>
                  ) : (
                    <S.ContainerForm>
                      <InputV3
                        id="Razão social"
                        type="text"
                        label="Razão social"
                        floatingLabelWithAsterisk="Razão social"
                        value={razaoSocialEmpresa}
                        onChange={(e) => {
                          setRazaoSocialEmpresa(e.target.value);

                          setErrorsEmpresa((prev) => {
                            const updatedErrors = {
                              ...prev,
                              razaoSocialEmpresa: false,
                            };
                            checkAllEmpresaErrors(updatedErrors);
                            return updatedErrors;
                          });
                        }}
                        hasError={errorsEmpresa.razaoSocialEmpresa}
                        handleClear={() => {
                          setRazaoSocialEmpresa("");
                        }}
                      />

                      <InputV3
                        id="Nome fantasia"
                        type="text"
                        label="Nome fantasia"
                        floatingLabelWithAsterisk="Nome fantasia"
                        value={nomeFantasiaEmpresa}
                        onChange={(e) => {
                          setNomeFantasiaEmpresa(e.target.value);

                          setErrorsEmpresa((prev) => {
                            const updatedErrors = {
                              ...prev,
                              nomeFantasiaEmpresa: false,
                            };
                            checkAllEmpresaErrors(updatedErrors);
                            return updatedErrors;
                          });
                        }}
                        hasError={errorsEmpresa.nomeFantasiaEmpresa}
                        handleClear={() => {
                          setNomeFantasiaEmpresa("");
                        }}
                      />

                      <InputV3
                        id="telefone/celular"
                        type="telefone/celular"
                        label="Telefone/Celular"
                        floatingLabelWithAsterisk="Telefone/Celular"
                        value={telefoneEmpresa}
                        onChange={(e) => {
                          setTelefoneEmpresa(e.target.value);

                          setErrorsEmpresa((prev) => {
                            const updatedErrors = {
                              ...prev,
                              telefoneEmpresa: false,
                            };
                            checkAllEmpresaErrors(updatedErrors);
                            return updatedErrors;
                          });
                        }}
                        hasError={errorsEmpresa.telefoneEmpresa}
                        handleClear={() => {
                          setTelefoneEmpresa("");
                        }}
                      />
                    </S.ContainerForm>
                  )}

                  <InputV3
                    id="cep"
                    type="text"
                    label="CEP"
                    floatingLabelWithAsterisk="CEP"
                    value={formatCEP(cepEmpresa)}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      setCepEmpresa(rawValue);

                      setErrorsEmpresa((prev) => {
                        const updatedErrors = { ...prev, cepEmpresa: false };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsEmpresa.cepEmpresa}
                    onBlur={() => {
                      if (validateCEP(cepEmpresa)) {
                        fetchCep(cepEmpresa, "empresa");
                      } else if (cepEmpresa) {
                        setErrorsEmpresa((prev) => {
                          const updatedErrors = { ...prev, cepEmpresa: true };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }
                    }}
                    maxLength={10}
                    inputMode="numeric"
                    onKeyDown={handleKeyDownAllowCopyPaste}
                    handleClear={() => {
                      setCepEmpresa("");
                    }}
                  />

                  <S.ContainerTwoInputs>
                    <InputV3
                      id="endereco"
                      type="text"
                      label="Endereço"
                      floatingLabelWithAsterisk="Endereço"
                      value={enderecoEmpresa}
                      onChange={(e) => {
                        setEnderecoEmpresa(e.target.value);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = {
                            ...prev,
                            enderecoEmpresa: false,
                          };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.enderecoEmpresa}
                      handleClear={() => {
                        setEnderecoEmpresa("");
                      }}
                    />

                    <InputV3
                      id="numero"
                      type="text"
                      label="Número"
                      floatingLabelWithAsterisk="Número"
                      value={numeroEmpresa}
                      onChange={(e) => {
                        setNumeroEmpresa(e.target.value);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = {
                            ...prev,
                            numeroEmpresa: false,
                          };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.numeroEmpresa}
                      handleClear={() => {
                        setNumeroEmpresa("");
                      }}
                    />
                  </S.ContainerTwoInputs>

                  <InputV3
                    id="complemento"
                    type="text"
                    label="Complemento"
                    floatingLabel="Complemento"
                    value={complementoEmpresa}
                    onChange={(e) => {
                      setComplementoEmpresa(e.target.value);

                      setErrorsEmpresa((prev) => {
                        const updatedErrors = {
                          ...prev,
                          complementoEmpresa: false,
                        };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    handleClear={() => {
                      setComplementoEmpresa("");
                    }}
                  />

                  <InputV3
                    id="bairro"
                    type="text"
                    label="Bairro"
                    floatingLabelWithAsterisk="Bairro"
                    value={bairroEmpresa}
                    onChange={(e) => {
                      setBairroEmpresa(e.target.value);

                      setErrorsEmpresa((prev) => {
                        const updatedErrors = { ...prev, bairroEmpresa: false };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsEmpresa.bairroEmpresa}
                    handleClear={() => {
                      setBairroEmpresa("");
                    }}
                  />

                  <S.ContainerTwoInputs>
                    <InputV3
                      id="cidade"
                      type="text"
                      label="Cidade"
                      floatingLabelWithAsterisk="Cidade"
                      value={cidadeEmpresa}
                      onChange={(e) => {
                        setCidadeEmpresa(e.target.value);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = {
                            ...prev,
                            cidadeEmpresa: false,
                          };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.cidadeEmpresa}
                      handleClear={() => {
                        setCidadeEmpresa("");
                      }}
                    />

                    <InputV3
                      id="EstadoEmpresa"
                      type="select"
                      typeValueSelect="string"
                      floatingLabelWithAsterisk="UF"
                      value={ufEmpresa.value}
                      onChange={(selectedOption) => {
                        setUfEmpresa(selectedOption);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = { ...prev, ufEmpresa: false };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      options={ufOptions}
                      hasError={errorsEmpresa.ufEmpresa}
                      floatingValue={ufEmpresa.value}
                    />
                  </S.ContainerTwoInputs>

                  {formatCPFOrCNPJ(cpfCnpjEmpresa)?.length === 14 ? (
                    ""
                  ) : (
                    <InputV3
                      id="inscrição_estadual"
                      type="text"
                      label="Inscrição Estadual"
                      floatingLabelWithAsterisk="Inscrição Estadual"
                      value={inscricaoEstadualEmpresa}
                      onChange={(e) => {
                        setInscricaoEstadualEmpresa(e.target.value);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = {
                            ...prev,
                            inscricaoEstadualEmpresa: false,
                          };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.inscricaoEstadualEmpresa}
                      handleClear={() => {
                        setInscricaoEstadualEmpresa("");
                      }}
                    />
                  )}

                  <InputV3
                    id="categoria"
                    type="select"
                    typeValueSelect="number"
                    label="Categoria"
                    floatingLabelWithAsterisk="Categoria"
                    value={categoriaEmpresa.label}
                    onChange={(selectedOption) => {
                      setCategoriaEmpresa(selectedOption);

                      setErrorsEmpresa((prev) => {
                        const updatedErrors = {
                          ...prev,
                          categoriaEmpresa: false,
                        };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    options={categoriaOptions}
                    hasError={errorsEmpresa.categoriaEmpresa}
                    floatingValue={categoriaEmpresa.label}
                  />
                </S.ContainerInputs>
              )}
            </S.ContainerForm>
          </S.ContainerInputs>
        </AcordionCard>

        <AcordionCard
          title="Dados de faturamento"
          isOpen={openAccordionKey === "faturamento"}
          hasError={acordionFaturamentoError}
          hasBlock={activeAccordionFaturamento}
          onToggle={(key) => {
            setOpenAccordionKey(key);
            handleAccordionToggle(key);

            allFieldsValid();
          }}
          accordionKey="faturamento"
        >
          <S.ContainerInputs>
            <S.ContainerButtonDataUser>
              <S.ButtonCopyDataUser onClick={handleCopyDataUser}>
                <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>
                  Copiar dados do usuário
                </TaglineM>
              </S.ButtonCopyDataUser>
            </S.ContainerButtonDataUser>

            <S.ContainerForm>
              <InputV3
                id="Nome do Responsável financeiro"
                type="text"
                label="Nome do Responsável financeiro"
                floatingLabelWithAsterisk="Nome do Responsável financeiro"
                value={nameUserFaturamento}
                onChange={(e) => {
                  setNameUserFaturamento(e.target.value);

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = {
                      ...prev,
                      nameUserFaturamento: false,
                    };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                hasError={errorsFaturamento.nameUserFaturamento}
                handleClear={() => {
                  setNameUserFaturamento("");
                }}
              />

              <InputV3
                id="email"
                type="email"
                autoComplete="email"
                label="E-mail"
                floatingLabelWithAsterisk="E-mail"
                value={emailUserFaturamento}
                onChange={(e) => {
                  setEmailUserFaturamento(e.target.value);

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = {
                      ...prev,
                      emailUserFaturamento: false,
                    };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                hasError={errorsFaturamento.emailUserFaturamento}
                handleClear={() => {
                  setEmailUserFaturamento("");
                }}
              />

              <InputV3
                id="Telefone/Celular"
                type="telefone/celular"
                label="Telefone/Celular"
                floatingLabelWithAsterisk="Telefone/Celular"
                value={phoneUserFaturamento}
                onChange={(e) => {
                  setPhoneUserFaturamento(e.target.value);

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = {
                      ...prev,
                      phoneUserFaturamento: false,
                    };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                hasError={errorsFaturamento.phoneUserFaturamento}
                handleClear={() => {
                  setPhoneUserFaturamento("");
                }}
              />

              <InputV3
                id="cargo_faturamento"
                type="text"
                label="Cargo faturamento"
                floatingLabelWithAsterisk="Cargo"
                value={cargoUserFaturamento}
                onChange={(e) => {
                  setCargoUserFaturamento(e.target.value);

                  setErrorsUser((prev) => {
                    const updatedErrors = {
                      ...prev,
                      cargoUserFaturamento: false,
                    };
                    checkAllUserErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                hasError={errorsFaturamento.cargoUserFaturamento}
                handleClear={() => {
                  setCargoUserFaturamento("");
                }}
              />

              <InputV3
                id="Departamento"
                type="select"
                typeValueSelect="number"
                floatingLabelWithAsterisk="Local de trabalho"
                value={workSpaceFaturamento.label}
                onChange={(selectedOption) => {
                  setWorkSpaceFaturamento({
                    value: selectedOption.value,
                    label: selectedOption.label,
                  });

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = {
                      ...prev,
                      workSpaceFaturamento: false,
                    };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                options={workSpaceOptions}
                hasError={errorsFaturamento.workSpaceFaturamento}
                floatingValue={workSpaceFaturamento.label}
              />

              <InputV3
                id="Número do Pedido"
                type="text"
                label="Número do Pedido"
                floatingLabel="Número do Pedido"
                value={numeroPedidoFaturamento}
                onChange={(e) => {
                  setNumeroPedidoFaturamento(e.target.value);

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = {
                      ...prev,
                      numeroPedidoFaturamento: false,
                    };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                handleClear={() => {
                  setNumeroPedidoFaturamento("");
                }}
              />
            </S.ContainerForm>
          </S.ContainerInputs>
        </AcordionCard>

        <AcordionCard
          title="Dados de pagamento"
          isOpen={openAccordionKey === "pagamento"}
          height={
            selectedMetod === "boleto" || selectedMetod === "pix" ? true : false
          }
          hasError={acordionPagamentoError}
          Padding={true}
          hasBlock={activeAccordionPagamento}
          onToggle={(key) => {
            setOpenAccordionKey(key);
            handleAccordionToggle(key);
          }}
          accordionKey="pagamento"
        >
          <S.ContainerContent>
            <S.ContainerInputs>
              <S.DescriptionPrice>
                {cupom || fullValueAnual ? (
                  selectedPlan?.label !== "PLANO PRÉ-PAGO" ? (
                    <S.ContainerCupomPriceDiscount>
                      <S.CupomPriceDiscount>
                        <BodyP
                          fontWeight={400}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Subtotal
                        </BodyP>

                        <BodyP
                          fontWeight={700}
                          color={theme.colors.gray.Cinza_2}
                        >
                          {/* {valueAnual ? 
                        formatCurrency(valueTotalWithDiscount) :
                          `R$ ${formatCurrency(valueMonthDiscount)}`} */}

                          {/* {fullValueAnual ? 
                          getValueCalcWithMonth() :
                          `R$ ${formatCurrency(valueMonth)}`} */}

                          {getValueCalcWithMonth()}
                        </BodyP>
                      </S.CupomPriceDiscount>

                      <S.CupomPriceDiscount>
                        <BodyP
                          fontWeight={400}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Desconto cupom
                        </BodyP>

                        <BodyP
                          fontWeight={700}
                          color={theme.colors.red.Tostado}
                        >
                          {fullValueAnual
                            ? getValueDiscountAnual()
                            : `-R$ ${calculateSubtotal()}`}
                        </BodyP>
                      </S.CupomPriceDiscount>
                    </S.ContainerCupomPriceDiscount>
                  ) : (
                    cupom && (
                    <S.ContainerCupomPriceDiscount>
                      <S.CupomPriceDiscount>
                        <BodyP
                          fontWeight={400}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Subtotal
                        </BodyP>

                        <BodyP
                          fontWeight={700}
                          color={theme.colors.gray.Cinza_2}
                        >
                          {/* {valueAnual ? 
                        formatCurrency(valueTotalWithDiscount) :
                          `R$ ${formatCurrency(valueMonthDiscount)}`} */}

                          {getValueCalcPrePago()}
                        </BodyP>
                      </S.CupomPriceDiscount>

                      <S.CupomPriceDiscount>
                        <BodyP
                          fontWeight={400}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Desconto cupom
                        </BodyP>

                        <BodyP
                          fontWeight={700}
                          color={theme.colors.red.Tostado}
                        >
                          -R$ {resultValueTotalWithDiscount}
                        </BodyP>
                      </S.CupomPriceDiscount>
                    </S.ContainerCupomPriceDiscount>
                      )
                  )
                ) : (
                  ""
                )}

                <S.TotalPrice>
                  <div
                    style={{
                      width: "192px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <H6 color={theme.colors.gray.Cinza_2}>Total a pagar</H6>
                  </div>

                  <div
                    style={{
                      width: "192px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <H6 color={theme.colors.gray.Cinza_2}>
                      R$ {getFormattedValue()}
                    </H6>

                    {/* {cupom && messageCupom ? (
                      <>
                        <Minimo
                          fontWeight={400}
                          color={theme.colors.gray.Cinza_5}
                        >
                          {messageCupom}
                        </Minimo>
                      </>
                    ) : (
                      ""
                    )} */}
                  </div>
                </S.TotalPrice>
              </S.DescriptionPrice>

              <S.ContainerCardPlans as="form" selectedPlan={selectedPlan}>
                {selectedPlan?.label !== "PLANO PRÉ-PAGO" ? (
                  <>
                    <CardRadio
                      selected={selectedMetod === "pix"}
                      onClick={() => {
                        setSelectedMetod("pix");

                        setAcordionPagamentoError(false);

                        setErrorsPagamento({
                          cpfOrCnpjPagamento: false,
                          emailPagamento: false,
                          phonePagamento: false,
                          cepPagamento: false,
                          enderecoPagamento: false,
                          numeroPagamento: false,
                          complementoPagamento: false,
                          bairroPagamento: false,
                          cidadePagamento: false,
                          ufPagamento: false,

                          nomeTitularCartao: false,
                          numeroCartao: false,
                          validade: false,
                          cvv: false,
                        });
                      }}
                      id="pix"
                      checked={selectedMetod === "pix"}
                      onChange={() => {
                        setSelectedMetod("pix");

                        setAcordionPagamentoError(false);
                      }}
                    >
                      <S.CardPlansHeader>
                        <BodyG
                          fontWeight={800}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Pix
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_5}>
                          Liberação imediata
                        </Auxiliar>
                      </S.CardPlansHeader>
                    </CardRadio>

                    <CardRadio
                      selected={selectedMetod === "boleto"}
                      onClick={() => {
                        setSelectedMetod("boleto");

                        setAcordionPagamentoError(false);

                        setErrorsPagamento({
                          cpfOrCnpjPagamento: false,
                          emailPagamento: false,
                          phonePagamento: false,
                          cepPagamento: false,
                          enderecoPagamento: false,
                          numeroPagamento: false,
                          complementoPagamento: false,
                          bairroPagamento: false,
                          cidadePagamento: false,
                          ufPagamento: false,

                          nomeTitularCartao: false,
                          numeroCartao: false,
                          validade: false,
                          cvv: false,
                        });
                      }}
                      id="boleto"
                      checked={selectedMetod === "boleto"}
                      onChange={() => {
                        setSelectedMetod("boleto");

                        setAcordionPagamentoError(false);
                      }}
                    >
                      <S.CardPlansHeader>
                        <BodyG
                          fontWeight={800}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Boleto
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_5}>
                          Até 3 dias para liberação
                        </Auxiliar>
                      </S.CardPlansHeader>
                    </CardRadio>

                    <CardRadio
                      selected={selectedMetod === "cartao_credito"}
                      onClick={() => setSelectedMetod("cartao_credito")}
                      id="cartao_credito"
                      checked={selectedMetod === "cartao_credito"}
                      onChange={() => setSelectedMetod("cartao_credito")}
                    >
                      <S.CardPlansHeader>
                        <BodyG
                          fontWeight={800}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Cartão de crédito
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_5}>
                          Liberação imediata
                        </Auxiliar>
                      </S.CardPlansHeader>
                    </CardRadio>
                  </>
                ) : (
                  <>
                    <CardRadio
                      selected={selectedMetod === "pix"}
                      onClick={() => {
                        setSelectedMetod("pix");

                        setAcordionPagamentoError(false);

                        setErrorsPagamento({
                          cpfOrCnpjPagamento: false,
                          emailPagamento: false,
                          phonePagamento: false,
                          cepPagamento: false,
                          enderecoPagamento: false,
                          numeroPagamento: false,
                          complementoPagamento: false,
                          bairroPagamento: false,
                          cidadePagamento: false,
                          ufPagamento: false,

                          nomeTitularCartao: false,
                          numeroCartao: false,
                          validade: false,
                          cvv: false,
                        });
                      }}
                      id="pix"
                      checked={selectedMetod === "pix"}
                      onChange={() => {
                        setSelectedMetod("pix");

                        setAcordionPagamentoError(false);
                      }}
                    >
                      <S.CardPlansHeader>
                        <BodyG
                          fontWeight={800}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Pix
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_5}>
                          Liberação imediata
                        </Auxiliar>
                      </S.CardPlansHeader>
                    </CardRadio>

                    <CardRadio
                      selected={selectedMetod === "boleto"}
                      onClick={() => {
                        setSelectedMetod("boleto");

                        setAcordionPagamentoError(false);

                        setErrorsPagamento({
                          cpfOrCnpjPagamento: false,
                          emailPagamento: false,
                          phonePagamento: false,
                          cepPagamento: false,
                          enderecoPagamento: false,
                          numeroPagamento: false,
                          complementoPagamento: false,
                          bairroPagamento: false,
                          cidadePagamento: false,
                          ufPagamento: false,

                          nomeTitularCartao: false,
                          numeroCartao: false,
                          validade: false,
                          cvv: false,
                        });
                      }}
                      id="boleto"
                      checked={selectedMetod === "boleto"}
                      onChange={() => {
                        setSelectedMetod("boleto");

                        setAcordionPagamentoError(false);
                      }}
                    >
                      <S.CardPlansHeader>
                        <BodyG
                          fontWeight={800}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Boleto
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_5}>
                          Até 3 dias para liberação
                        </Auxiliar>
                      </S.CardPlansHeader>
                    </CardRadio>

                    <CardRadio
                      selected={selectedMetod === "cartao_credito"}
                      onClick={() => setSelectedMetod("cartao_credito")}
                      id="cartao_credito"
                      checked={selectedMetod === "cartao_credito"}
                      onChange={() => setSelectedMetod("cartao_credito")}
                    >
                      <S.CardPlansHeader>
                        <BodyG
                          fontWeight={800}
                          color={theme.colors.gray.Cinza_2}
                        >
                          Cartão de crédito
                        </BodyG>

                        <Auxiliar color={theme.colors.gray.Cinza_5}>
                          Liberação imediata
                        </Auxiliar>
                      </S.CardPlansHeader>
                    </CardRadio>
                  </>
                )}
              </S.ContainerCardPlans>

              {selectedMetod === "boleto" || selectedMetod === "pix" ? (
                ""
              ) : (
                <S.ContainerForm>
                  {isAnnualPlanSelected ? (
                    <InputV3
                      id="parcelas"
                      type="select"
                      label="Parcelas"
                      floatingLabelWithAsterisk="Parcelas"
                      typeValueSelect="number"
                      onChange={(selectedOption) => {
                        const matched = parcelasOptions.find(
                          (opt) =>
                            Number(opt?.value) === Number(selectedOption?.value)
                        );
                        setSelectedParcelas(matched || selectedOption);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, parcelas: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      options={parcelasOptions}
                      hasError={errorsPagamento.parcelas}
                    />
                  ) : null}

                  <InputV3
                    id="CPF/CNPJ do titular"
                    type="text"
                    label="CPF/CNPJ do titular"
                    floatingLabelWithAsterisk="CPF/CNPJ do titular"
                    value={formatCPFOrCNPJ(cpfOrCnpjPagamento)}
                    onChange={async (e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      setCpfOrCnpjPagamento(rawValue);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = {
                          ...prev,
                          cpfOrCnpjPagamento: false,
                        };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });

                      if (rawValue.length === 11 || rawValue.length === 14) {
                        const checkId = ++cpfOrCnpjPagamentoCheckRef.current;
                        const resultado = await validadorCpfCnpj(rawValue);
                        if (checkId !== cpfOrCnpjPagamentoCheckRef.current) return; // usuário já digitou algo novo, descarta resposta desatualizada

                        if (!resultado.valido) {
                          setErrorsPagamento((prev) => ({
                            ...prev,
                            cpfOrCnpjPagamento: true,
                          }));

                          store.addNotification({
                            title: "CPF/CNPJ inválido!",
                            message: resultado.erro || "Por favor, digite um CPF ou CNPJ válido.",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                              duration: 4000,
                              onScreen: true,
                            },
                          });
                        }
                      }
                    }}
                    onBlur={() => {
                      handleCnpj(cpfOrCnpjPagamento, "pagamento");
                      checkAndCopyEmpresaData();
                    }}
                    onKeyDown={handleKeyDownAllowCopyPaste}
                    inputMode="numeric"
                    maxLength={18}
                    hasError={errorsPagamento.cpfOrCnpjPagamento}
                    handleClear={() => {
                      setCpfOrCnpjPagamento("");
                    }}
                  />

                  <InputV3
                    id="email"
                    type="email"
                    autoComplete="email"
                    label="E-mail"
                    floatingLabelWithAsterisk="E-mail"
                    value={emailPagamento}
                    onChange={(e) => {
                      setEmailPagamento(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = {
                          ...prev,
                          emailPagamento: false,
                        };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.emailPagamento}
                    handleClear={() => {
                      setEmailPagamento("");
                    }}
                  />

                  <InputV3
                    id="Telefone/Celular"
                    type="telefone/celular"
                    label="Telefone/Celular"
                    floatingLabelWithAsterisk="Telefone/Celular"
                    value={phonePagamento}
                    onChange={(e) => {
                      setPhonePagamento(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = {
                          ...prev,
                          phonePagamento: false,
                        };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.phonePagamento}
                    handleClear={() => {
                      setPhonePagamento("");
                    }}
                  />

                  <InputV3
                    id="CEP"
                    type="text"
                    label="CEP"
                    floatingLabelWithAsterisk="CEP"
                    value={formatCEP(cepPagamento)}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      setCepPagamento(rawValue);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, cepPagamento: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });

                      if (rawValue.length === 8) {
                        fetchCep(rawValue, "pagamento");
                      }
                    }}
                    hasError={errorsPagamento.cepPagamento}
                    onBlur={() => {
                      if (validateCEP(cepPagamento)) {
                        fetchCep(cepPagamento, "pagamento");
                      } else if (cepPagamento) {
                        setErrorsPagamento((prev) => ({
                          ...prev,
                          cepPagamento: true,
                        }));
                      }
                    }}
                    maxLength={10}
                    inputMode="numeric"
                    onKeyDown={handleKeyDownAllowCopyPaste}
                    handleClear={() => {
                      setCepPagamento("");
                    }}
                  />

                  <S.ContainerTwoInputs>
                    <InputV3
                      id="Endereço"
                      type="text"
                      label="Endereço"
                      floatingLabelWithAsterisk="Endereço"
                      value={enderecoPagamento}
                      onChange={(e) => {
                        setEnderecoPagamento(e.target.value);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = {
                            ...prev,
                            enderecoPagamento: false,
                          };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsPagamento.enderecoPagamento}
                      handleClear={() => {
                        setEnderecoPagamento("");
                      }}
                    />

                    <InputV3
                      id="Número"
                      type="text"
                      label="Número"
                      floatingLabelWithAsterisk="Número"
                      value={numeroPagamento}
                      onChange={(e) => {
                        setNumeroPagamento(e.target.value);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = {
                            ...prev,
                            numeroPagamento: false,
                          };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsPagamento.numeroPagamento}
                      handleClear={() => {
                        setNumeroPagamento("");
                      }}
                    />
                  </S.ContainerTwoInputs>

                  <InputV3
                    id="Complemento"
                    type="text"
                    label="Complemento"
                    floatingLabel="Complemento"
                    value={complementoPagamento}
                    onChange={(e) => {
                      setComplementoPagamento(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = {
                          ...prev,
                          complementoPagamento: false,
                        };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.complementoPagamento}
                    handleClear={() => {
                      setComplementoPagamento("");
                    }}
                  />

                  <InputV3
                    id="Bairro"
                    type="text"
                    label="Bairro"
                    floatingLabelWithAsterisk="Bairro"
                    value={bairroPagamento}
                    onChange={(e) => {
                      setBairroPagamento(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = {
                          ...prev,
                          bairroPagamento: false,
                        };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.bairroPagamento}
                    handleClear={() => {
                      setBairroPagamento("");
                    }}
                  />

                  <S.ContainerTwoInputs>
                    <InputV3
                      id="Cidade"
                      type="text"
                      label="Cidade"
                      floatingLabelWithAsterisk="Cidade"
                      value={cidadePagamento}
                      onChange={(e) => {
                        setCidadePagamento(e.target.value);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = {
                            ...prev,
                            cidadePagamento: false,
                          };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsPagamento.cidadePagamento}
                      handleClear={() => {
                        setCidadePagamento("");
                      }}
                    />

                    <InputV3
                      id="UF"
                      type="select"
                      typeValueSelect="string"
                      floatingLabelWithAsterisk="UF"
                      value={ufPagamento.value}
                      onChange={(selectedOption) => {
                        setUFPagamento(selectedOption);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, ufPagamento: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      options={ufOptions}
                      hasError={errorsPagamento.ufPagamento}
                      floatingValue={ufPagamento.value}
                    />
                  </S.ContainerTwoInputs>

                  <InputV3
                    id="Nome do titular (conforme impresso no cartão)"
                    type="text"
                    label="Nome do titular (conforme impresso no cartão)"
                    floatingLabelWithAsterisk="Nome do titular (conforme impresso no cartão)"
                    value={nomeTitularCartao}
                    onChange={(e) => {
                      setNomeTitularCartao(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = {
                          ...prev,
                          nomeTitularCartao: false,
                        };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.nomeTitularCartao}
                    handleClear={() => {
                      setNomeTitularCartao("");
                    }}
                  />

                  <InputV3
                    id="Número do cartão"
                    type="text"
                    label="Número do cartão"
                    floatingLabelWithAsterisk="Número do cartão"
                    value={formatCardNumber(numeroCartao)}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      setNumeroCartao(rawValue);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, numeroCartao: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    onBlur={() => {
                      if (numeroCartao && !validateCardNumber(numeroCartao)) {
                        setErrorsPagamento((prev) => ({
                          ...prev,
                          numeroCartao: true,
                        }));
                      }
                    }}
                    hasError={errorsPagamento.numeroCartao}
                    inputMode="numeric"
                    maxLength={19}
                    onKeyDown={handleKeyDownAllowCopyPaste}
                    handleClear={() => {
                      setNumeroCartao("");
                    }}
                  />

                  <S.ContainerTwoInputs>
                    <InputV3
                      id="Validade (mm/aaaa)"
                      type="text"
                      label="Validade (mm/aaaa)"
                      floatingLabelWithAsterisk="Validade (mm/aaaa)"
                      value={formatExpiryDate(validade)}
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/\D/g, "");
                        setValidade(rawValue);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, validade: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      onBlur={() => {
                        if (
                          validade &&
                          !validateExpiryDate(formatExpiryDate(validade))
                        ) {
                          setErrorsPagamento((prev) => ({
                            ...prev,
                            validade: true,
                          }));
                        }
                      }}
                      hasError={errorsPagamento.validade}
                      inputMode="numeric"
                      maxLength={7}
                      placeholder="MM/AAAA"
                      onKeyDown={handleKeyDownAllowCopyPaste}
                      handleClear={() => {
                        setValidade("");
                      }}
                    />

                    <InputV3
                      id="CVV"
                      type="text"
                      label="CVV"
                      floatingLabelWithAsterisk="CVV"
                      value={formatCVV(cvv)}
                      onChange={(e) => {
                        const rawValue = formatCVV(e.target.value);
                        setCvv(rawValue);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, cvv: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      onBlur={() => {
                        if (cvv && !validateCVV(cvv)) {
                          setErrorsPagamento((prev) => ({
                            ...prev,
                            cvv: true,
                          }));
                        }
                      }}
                      hasError={errorsPagamento.cvv}
                      inputMode="numeric"
                      maxLength={4}
                      onKeyDown={handleKeyDownAllowCopyPaste}
                      handleClear={() => {
                        setCvv("");
                      }}
                    />
                  </S.ContainerTwoInputs>
                </S.ContainerForm>
              )}
            </S.ContainerInputs>

            {selectedPlan?.label !== "PLANO PRÉ-PAGO" &&
            fullValueAnual === null &&
            cupom === "BEMVINDO" ? (
              <Minimo
                style={{ textAlign: "center" }}
                color={theme.colors.gray.Cinza_2}
              >
                A partir da segunda mensalidade:{" "}
                <b>R$ {valueMonthDiscount}/mês</b>
              </Minimo>
            ) : (
              ""
            )}
          </S.ContainerContent>
        </AcordionCard>

        <S.ContainerCheckbox>
          <S.ContainerInputCheckbox>
            <input
              type="checkbox"
              id="termosPolitica"
              name="termosPolitica"
              checked={termosAceitos}
              onChange={(e) => setTermosAceitos(e.target.checked)}
            />

            <BodyP>
              Li e concordo com os{" "}
              <span onClick={() => handleTermosClick()}>Termos de uso</span> e a{" "}
              <span onClick={() => handlePoliticaClick()}>
                Politica de Privacidade
              </span>
            </BodyP>
          </S.ContainerInputCheckbox>

          <S.ContainerInputCheckbox>
            <input
              type="checkbox"
              id="declaroAcordo"
              name="declaroAcordo"
              checked={acordoAceito}
              onChange={(e) => setAcordoAceito(e.target.checked)}
            />
            <BodyP>Declaro que estou ciente e de acordo</BodyP>
          </S.ContainerInputCheckbox>
        </S.ContainerCheckbox>

        <S.ButtonSubmit
          isDisabled={!termosAceitos || !acordoAceito || errorsPlan.selectedPlan}
          onClick={() => {
            if (!termosAceitos || !acordoAceito || errorsPlan.selectedPlan) return;
            handleSubmit();
          }}
        >
          {isConfirmLoading ? (
            <S.Loading />
          ) : (
            <TaglineM fontWeight={800}>Concluir compra</TaglineM>
          )}
        </S.ButtonSubmit>
      </S.Wrapper>

      <ModalTermos
        show={showTermos}
        btnOk={true}
        onHide={() => setShowTermos(false)}
      />

      <ModalPoliticas
        show={showPolitica}
        btnOk={true}
        onHide={() => setShowPolitica(false)}
      />

      <ModalYesNoV2
        show={showPendingModal}
        title="Você tem uma compra pendente"
        text="Existe uma compra pendente na sua conta. Deseja substituir por essa nova compra?"
        subtext="Ao confirmar, cancelaremos a sua compra pendente."
        image={ModalImage}
        update={handlePendingModalUpdate}
        onHide={() => handlePendingModalUpdate(0)}
      />
    </S.Container>
  );
};

export default Compra;
